export const guj_language_data = {
  Loading: "લોડ કરી રહ્યું છે",
  Login: "લોગીન",
  LoginWithUsernameandPassword:
    "તમારા વપરાશકર્તા નામ અને પાસવર્ડ સાથે લોગિન કરો",
  UserID: "વપરાશકર્તા આઈડી",
  Password: "પાસવર્ડ",
  EnterUserName: "વપરાશકર્તા નામ દાખલ કરો",
  EnterPassword: "પાસવર્ડ દાખલ કરો",
  EnterPasswordValid: "પાસવર્ડ 8 થી 16 અક્ષરોની વચ્ચે હોવો જોઈએ.",
  EnterPasswordPolicy:
    "પાસવર્ડ 8-16 અક્ષરો લાંબો હોવો જોઈએ, એટલે ઓછામાં ઓછી એક અપરકેસ અક્ષર, એક લોઅરકેસ અક્ષર, એક નંબર અને એક વિશેષ પાસવર્ડ અક્ષર હોવું જરૂરી છે, અને કોઈ જગ્યા નહીં દીધી જોઈએ.",
  ForgotPassword: "પાસવર્ડ ભૂલી ગયા છો?",
  UsernameisRequired: "વપરાશકર્તા નામ આવશ્યક છે",
  PasswordisRequired: "પાસવર્ડ જરૂરી છે",
  MobileNoisRequired: "મોબાઈલ નંબર જરૂરી છે",
  MobileNoisValid: "કૃપા કરીને માન્ય મોબાઇલ નંબર દાખલ કરો.",
  UserNm: "વપરાશકર્તા નામ",
  UsernamenandPasswordisRequired: "વપરાશકર્તા નામ અને પાસવર્ડ આવશ્યક છે",
  ThisFieldisrequired: "આ ફિલ્ડ ભરવી જરૂરી છે.",
  Next: "આગળ",
  backtologin: "લોગિન પર પાછા",
  Save: "સાચવો",
  Yes: "હા",
  No: "ના",
  Nodatafound: "કોઈ ડેટા મળ્યો નથી..!",
  Confirmation: "પુષ્ટિકરણ",
  Filter: "ફિલ્ટર",
  Apply: "અરજી કરો",
  Clear: "ચોખ્ખુ",
  FailedToAddFollowingFilesForUpload:
    "અપલોડ માટે નીચેની ફાઇલો ઉમેરવામાં નિષ્ફળ",
  FileUpload: "ફાઇલ અપલોડ કરો",
  FileViewer: "ફાઇલ દર્શક",
  File: "ફાઇલ",
  Type: "પ્રકાર",
  Size: "કદ",
  DoyouwanttosavethisRequest: "શું તમે આ વિનંતી સાચવવા માંગો છો?",
  DoyouwanttosavethisRecord: "શું તમે આ રેકોર્ડ સાચવવા માંગો છો?",
  DoyouwanttoacceptthisRequest: "શું તમે આ વિનંતી સ્વીકારવા માંગો છો?",
  Doyouwanttorevertthisrequest: "શું તમે આ વિનંતિને પાછી વાળવા માંગો છો?",
  DoYouwanttorejectthisRequest: "શું તમે આ વિનંતીને નકારવા માંગો છો?",
  Youcannotacceptyourownentry: "તમે તમારી પોતાની એન્ટ્રી સ્વીકારી શકતા નથી.",
  Youcannotrejectyourownentry: "તમે તમારી પોતાની એન્ટ્રીને નકારી શકતા નથી.",
  Youcannotconfirmyourownentry:
    "તમે તમારી પોતાની એન્ટ્રીની પુષ્ટિ કરી શકતા નથી.",
  RecordUpdatedsuccessfully: "રેકોર્ડ સફળતાપૂર્વક અપડેટ થયો.",
  ImageUpdatedsuccessfully: "છબી સફળતાપૂર્વક અપડેટ થઈ.",
  Somethingwenttowrong: "કંઈક ખોટું થયું..",
  Recordssuccessfullydeleted: "રેકોર્ડ સફળતાપૂર્વક કાઢી નાખ્યા",
  Requesthasbeenalreadyaccepted: "વિનંતી પહેલેથી જ સ્વીકારવામાં આવી છે.",
  Requesthasbeenalreadyrejected: "વિનંતી પહેલાથી જ નકારી કાઢવામાં આવી છે.",
  Areyousuretoupdateservices: "શું તમે સેવાઓ અપડેટ કરવાની ખાતરી કરો છો?",
  Passwordsuccessfullyreset: "પાસવર્ડ સફળતાપૂર્વક રીસેટ થયો",
  success: "સફળતા",
  Deleting: "કાઢી રહ્યું છે...",
  profile: {
    UserProfile: "વપરાશકર્તા પ્રોફાઇલ",
    EnableTOTPAuth: "T-OTP ઑથ ચાલુ કરો",
    DisableTOTPAuth: "T-OTP ઑથ બંધ કરો",
    ChangePassword: "પાસવર્ડ બદલો",
    LoginDate: "લૉગિન તારીખ",
    UserID: "વપરાશકર્તા આઈડી",
    Name: "નામ",
    LoginID: "લૉગિન આઈડી",
    LoginFlag: "લૉગિન ફ્લેગ",
    LogoutDate: "લૉગઆઉટ તારીખ",
    ActivityRemarks: "પ્રવૃત્તિ ટિપ્પણી",
    IPAddress: "આઈપી સરનામું",
    ReleasedUser: "રીલીઝ કરેલ યુઝર",
    ReleasedDate: "રિલીઝ તારીખ",
    SrNo: "ક્રમ નં",
    UserLevel: "વપરાશકર્તા સ્તર",
    MobileNumber: "મોબાઇલ નંબર",
    EnterMobileNumber: "મોબાઇલ નંબર દાખલ કરો",
    EmailID: "ઈમેલ આઈડી",
    UserGroup: "વપરાશકર્તા જૂથ",
    UserSubType: "વપરાશકર્તા પેટા પ્રકાર",
    BranchName: "શાખાનું નામ",
    AllowedRelease: "મંજૂર પ્રકાશન",
    required: "આ ક્ષેત્રો જરૂરી છે",
    Searchin: "{0} રેકોર્ડમાં શોધો",
    SearchinScreens: "{0} સ્ક્રીનમાં શોધો",
    screens: "સ્ક્રીનમાં શોધો",
    records: "રેકોર્ડમાં શોધો",
    // For Change Password in Profile
    CurrentPassword: "અત્યારનો પાસવર્ડ",
    NewPassword: "નવો પાસવર્ડ",
    ConfirmPassword: "પાસવર્ડની પુષ્ટિ કરો",
    Close: "બંધ",
    PasswordValidation: "નવો પાસવર્ડ જૂના પાસવર્ડ જેવો ન હોવો જોઈએ.",
    ChangePasswordValidation:
      "પાસવર્ડ આલ્ફાન્યૂમેરિક હોવો જોઈએ અને તેમાં ઓછામાં ઓછું એક ખાસ કેરેક્ટર,એક સ્મોલ કેરેક્ટર,એક કેપિટલ કેરેક્ટર તેની વચ્ચે કોઈ જગ્યા વગર હોવો જોઈએ.",
    ConfirmPasswordValidation: "નવો પાસવર્ડ અને કન્ફર્મ પાસવર્ડ મેળ ખાતા નથી",
    SetNewPassword: "નવો પાસવર્ડ સેટ કરો",
    EnterConfirmPassword: "કન્ફર્મ પાસવર્ડ દાખલ કરો",
    // For Password in Verify
    PasswordVerify: "પાસવર્ડ ચકાસો",
    Verify: "ચકાસો",
    ConfirmPasswordRequired: "પુષ્ટિ કરો પાસવર્ડ જરૂરી છે.",

    // For T-OTP in Profile
    EnabledAuth: "સક્ષમ પ્રમાણકર્તા",
    TOTP_Note: "નોંધ : સક્ષમ પ્રમાણકર્તા",
    TOTP_Note1:
      "QR કોડ સ્કેન કરો: આપેલા QR કોડને સ્કેન કરવા માટે કોઈપણ પ્રમાણકર્તા એપ્લિકેશનનો ઉપયોગ કરો.",
    TOTP_Note2:
      "દ્વિ-પરિબળ પ્રમાણીકરણ સક્ષમ કરો: ઉન્નત સુરક્ષા માટે સમય-આધારિત એક વાર પાસવર્ડ (TOTP) પદ્ધતિનો ઉપયોગ કરો.",
    TOTP_Note3:
      "QR કોડ સ્કેન કરવાની સૂચના: વપરાશકર્તાને તેમની પસંદ કરેલ પ્રમાણકર્તા એપ્લિકેશનમાં QR કોડ સ્કેન કરવાની સૂચના આપો.",
    TOTP_Note4:
      "OTP ચકાસો: સ્કેન કર્યા પછી, વપરાશકર્તાએ એપ દ્વારા જનરેટ કરાયેલ એક વાર પાસવર્ડ (OTP) ચકાસવો જોઈએ.",
    EnterOTP: "કૃપા કરીને OTP દાખલ કરો",
    VerifyOTP: "OTP ચકાસો",
  },

  // For OTP Verify
  otp: {
    OTPAuthentication: "ઓટીપી પ્રમાણીકરણ",
    PleaseEnterOTP: "કૃપા કરીને OTP દાખલ કરો",
    Back: "પાછા",
    Verify: "ચકાસો",
    ResendOTP: "ઓટીપી ફરીથી મોકલો",
    EnterOTPDigit: "કૃપા કરીને 6 અંકનો OTP નંબર દાખલ કરો",
    ResendOTPIn: "OTP",
    Scecond: "સેકન્ડમાં ફરીથી મોકલો.",
  },
  // For Appbar
  appBar: {
    Branch: "શાખા",
    LastLogin: "છેલ્લું લૉગિન",
    UserID: "વપરાશકર્તા આઈડી",
    Role: "ભૂમિકા",
    Profile: "પ્રોફાઇલ",
    Logout: "લૉગ આઉટ",
  },

  dashBoard: {
    LatestTransactions: "નવીનતમ વ્યવહારો",
    TrafficByDevice: "ઉપકરણ દ્વારા ટ્રાફિક",
    Success: "સફળતા",
    Fail: "નિષ્ફળ",
    Today: "આજે",
    LastWeek: "છેલ્લું અઠવાડિયું",
    LastMonth: "છેલ્લો મહિનો",
  },
  Web: "વેબ",
  IOS: "આઇઓએસ",
  Android: "એન્ડ્રોઇડ",
  Huawei: "હ્યુઆવેઇ",

  // All Screen
  Custom: "કસ્ટમ",
  AllScreens: "બધી સ્ક્રીન",
  ScreenName: "સ્ક્રીન નામ",
  UserCode: "વપરાશકર્તા કોડ",
  SystemCode: "સિસ્ટમ કોડ",
  Release: "પ્રકાશન",
  ServiceActiveDeactiveConfiguration: "સેવા સક્રિય/નિષ્ક્રિય રૂપરેખાંકન ",
  SrNo: "ક્રમ નં",
  ServiceName: "સેવાનું નામ",
  Status: "સ્થિતિ",
  AccessChannel: "ચેનલ ઍક્સેસ કરો",
  CardUser: "કાર્ડ યુઝર",
  NonCardUser: "નોન કાર્ડ યુઝર",
  ServiceStopAlertMessage: "સર્વિસ સ્ટોપ એલર્ટ મેસેજ",
  EnterServiceStopAlertMessage: "સર્વિસ સ્ટોપ એલર્ટ મેસેજ દાખલ કરો",
  TotalNoofRecords: "કુલ સંખ્યા",
  MessageEnglish: "સંદેશ (અંગ્રેજી)",
  EnterMessageEnglish: "સંદેશ દાખલ કરો (અંગ્રેજી)",
  MessageLocal: "સંદેશ (સ્થાનિક)",
  EnterMessageLocal: "સંદેશ દાખલ કરો (સ્થાનિક)",
  ServiceDeactivationConfigurationDetails:
    "સેવા નિષ્ક્રિયકરણ રૂપરેખાંકન  વિગતો",
  FromDate: "તારીખ થી*",
  ToDate: "આજ સુધી*",
  Active: "સક્રિય",
  Action: "ક્રિયા",
  FromDateToDate: "તારીખથી આજની તારીખ કરતા ઓછી હોવી જોઈએ.",
  ToDateFromDate: "આજની તારીખથી તારીખથી મોટી હોવી જોઈએ.",
  FromDateToDatePrevious: "તારીખથી તારીખ પહેલાની તારીખ કરતા વધારે હોવી જોઈએ.",
  // Save: "સાચવો",
  Cancel: "રદ કરો",
  Edit: "ફેરફાર કરો",
  New: "નવું",
  confirm: "પુષ્ટિ કરો",
  Close: "બંધ",
  // Closes: "બંધ",
  Add: "ઉમેરો",
  AddRow: "પંક્તિ ઉમેરો",
  EditDetail: "વિગતો સંપાદિત કરો",
  ViewDetails: "વિગતો જુઓ",
  ViewFile: "ફાઇલ જુઓ",
  ClearAll: "બધું સાફ કરો",
  Ok: "ઠીક છે",
  view: "જુઓ",
  Delete: "કાઢી નાખો",
  Update: "અપડેટ કરો",
  PopulateBusinessDay: "વ્યવસાય દિવસની વસ્તી બનાવો",
  DateWiseServiceDisable: "તારીખ મુજબ સેવા નિષ્ક્રિય કરો",
  Messages: "સંદેશાઓ",
  Selected: "પસંદ કરેલ",
  // Rowsperpage: "પૃષ્ઠ દીઠ પંક્તિઓ:",

  //Marquee Text Configuration
  MarqueeTextConfiguration: "માર્કી લખાણ રૂપરેખાંકન ",
  Channel: "ચેનલ",
  MarqueeTextEnglish: "માર્કી લખાણ (અંગ્રેજી)",
  MarqueeTextLocal: "માર્કી લખાણ (સ્થાનિક)",
  EffectiveFrom: "થી અસરકારક",
  EffectiveTo: "માટે અસરકારક",
  EnterEffectiveFrom: "થી અસરકારક દાખલ કરો",
  EnterMarqueeTextEnglish: "માર્કી લખાણ દાખલ કરો (અંગ્રેજી)",
  EnterMarqueeTextLocal: "માર્કી લખાણ દાખલ કરો (સ્થાનિક)",
  Mustbeavaliddate: "માન્ય તારીખ હોવી આવશ્યક છે",
  EffectiveToshouldbegreaterthanorequaltoEffectiveFrom:
    "માટે અસરકારક એ થી અસરકારક કરતા વધારે અથવા બરાબર હોવું જોઈએ.",
  Wouldyouliketodeletetheselectedrecord:
    "શું તમે પસંદ કરેલ રેકોર્ડ કાઢી નાખવા માંગો છો?",
  CommonMessageTemplete: "સામાન્ય સંદેશનો નમૂનો",
  SelectCommonMessageTemplete: "સામાન્ય સંદેશ નમૂનો પસંદ કરો",

  //Email Account Setup

  EmailAccountSetup: "ઈ-મેલ SMTP સર્વર રૂપરેખાંકન",
  SentByName: "નામથી મોકલેલ",
  SMTPServerIP: "SMTP સર્વર આઇપી",
  Port: "પોર્ટ",
  SSLEnabled: "SSL સક્ષમ",
  SecurePasswordAuthentication: "સુરક્ષિત પાસવર્ડ પ્રમાણીકરણ",
  SecurePasswordAuthenticationEnabled: "સુરક્ષિત પાસવર્ડ પ્રમાણીકરણ સક્ષમ",
  PassAuth: "પ્રમાણીકરણ પાસ કરો",
  UserName: "વપરાશકર્તા નામ",
  // Password: "પાસવર્ડ",
  SMTPServer: "SMTP સર્વર",
  PortNo: "પોર્ટ નં",
  NoteEMailSMTP:
    "નોંધ :- કૃપા કરીને ખાતરી કરો કે તમારું ઈ-મેલ એકાઉન્ટ SMTP માટે સક્ષમ છે.",
  EnterSentByName: "નામથી મોકલેલ દાખલ કરો",
  EnterSMTPServer: "SMTP સર્વર દાખલ કરો",
  EnterPortNo: "પોર્ટ નંબર દાખલ કરો",
  // EnterUserName: "વપરાશકર્તા નામ દાખલ કરો",
  // EnterPassword: "પાસવર્ડ દાખલ કરો",

  // District Master
  DistrictMaster: "જીલ્લા માસ્તર",
  DistrictCode: "જિલ્લા કોડ",
  DistrictName: "જિલ્લાનું નામ",
  DivisionCode: "વિભાગ કોડ",
  DivisionName: "વિભાગનું નામ",
  GeoCode: "જીઓ કોડ",
  DistCD: "જિ. કોડ",
  EnterDistrictCode: "જીલ્લા કોડ દાખલ કરો",
  EnterDistrictName: "જિલ્લાનું નામ દાખલ કરો",
  EnterDivisionCode: "વિભાગ કોડ દાખલ કરો",
  EnterDivisionName: "વિભાગનું નામ દાખલ કરો",
  EnterGeoCode: "જીઓ કોડ દાખલ કરો",
  EnterDistCD: "જિ. કોડ દાખલ કરો",

  // Service Wise Configuration

  ServiceWiseConfiguration: "સેવા મુજબનું રૂપરેખાંકન ",
  Description: "વર્ણન",
  EnterDescription: "વર્ણન દાખલ કરો",
  DailyLimit: "દૈનિક મર્યાદા",
  MinimumAmount: "લઘુત્તમ રકમ",
  MaximumAmount: "મહત્તમ રકમ",
  TransactionType: "વ્યવહારનો પ્રકાર",
  ConfirmStatus: "સ્થિતિની પુષ્ટિ કરો",
  ModifiedBy: "દ્વારા ફેરફાર",
  ModifiedDate: "સુધારેલી તારીખ",

  EnterDailyLimit: "દૈનિક મર્યાદા દાખલ કરો",
  WeeklyLimit: "સાપ્તાહિક મર્યાદા",
  EnterWeeklyLimit: "સાપ્તાહિક મર્યાદા દાખલ કરો",
  MonthlyLimit: "માસિક મર્યાદા",
  EnterMonthlyLimit: "માસિક મર્યાદા દાખલ કરો",
  EnterMinimumAmount: "લઘુત્તમ રકમ દાખલ કરો",
  EnterMaximumAmount: "મહત્તમ રકમ દાખલ કરો",
  CardMinimumAmount: "કાર્ડ લઘુત્તમ રકમ",
  EnterCardMinimumAmount: "કાર્ડ લઘુત્તમ રકમ દાખલ કરો",
  Execution: "અમલ",
  StartTime: "પ્રારંભ સમય",
  EnterStartTime: "પ્રારંભ સમય દાખલ કરો",
  EndTime: "સમાપ્તિ સમય",
  EnterEndTime: "સમાપ્તિ સમય દાખલ કરો",
  VATPercentage: "VAT ટકાવારી",
  EnterVATPercentage: "VAT ટકાવારી દાખલ કરો",
  MerchantID: "વેપારી ID",
  EnterMerchantID: "વેપારી ID દાખલ કરો",
  TerminalID: "ટર્મિનલ ID",
  EnterTerminalID: "ટર્મિનલ ID દાખલ કરો",
  WorkingDayStartFrom: "કામકાજના દિવસની શરૂઆત",
  CoolDownPeriodInMinute: "કૂલ ડાઉન પીરિયડ (મિનિટમાં)",
  EnterCoolDownPeriodInMinute: "કૂલ ડાઉન પીરિયડ દાખલ કરો (મિનિટમાં)",
  MaxDailyCount: "મહત્તમ દૈનિક ગણતરી",
  EnterMaxDailyCount: "મહત્તમ દૈનિક ગણતરી દાખલ કરો",
  MaxMonthlyCount: "મહત્તમ માસિક ગણતરી",
  EnterMaxMonthlyCount: "મહત્તમ માસિક ગણતરી દાખલ કરો",
  AmountLabel: "રકમ લેબલ",
  Accept: "સ્વીકારો",
  Revert: "પાછા ફરો",
  Reject: "અસ્વીકાર કરો",

  Charge: "ચાર્જ",
  ServiceChargeTemplate: "સર્વિસ ચાર્જ નમૂનો",
  SelectServiceChargeTemplate: "સર્વિસ ચાર્જ નમૂનો પસંદ કરો",
  ServiceChargeAccount: "સર્વિસ ચાર્જ ખાતું",
  EnterServiceChargeAccount: "સર્વિસ ચાર્જ ખાતું દાખલ કરો",
  VATAccount: "VAT એકાઉન્ટ",
  EnterVATAccount: "VAT એકાઉન્ટ દાખલ કરો",
  TransactionParticulars: "વ્યવહારની વિગતો",
  FinacleSuspenseCreditAccount: "ફિનાકલ સસ્પેન્સ ક્રેડિટ ખાતું",
  EnterFinacleSuspenseCreditAccount: "ફિનાકલ સસ્પેન્સ ક્રેડિટ ખાતું દાખલ કરો",
  FinacleSuspenseDebitAccount: "ફિનાકલ સસ્પેન્સ ડેબિટ ખાતું",
  EnterFinacleSuspenseDebitAccount: "ફિનાકલ સસ્પેન્સ ડેબિટ ખાતું દાખલ કરો",
  AbabilSuspenseCreditAccount: "અબાબીલ સસ્પેન્સ ક્રેડિટ ખાતું",
  EnterAbabilSuspenseCreditAccount: "અબાબીલ સસ્પેન્સ ક્રેડિટ ખાતું દાખલ કરો",
  AbabilSuspenseDebitAccount: "અબાબીલ સસ્પેન્સ ડેબિટ ખાતું",
  EnterAbabilSuspenseDebitAccount: "અબાબીલ સસ્પેન્સ ડેબિટ ખાતું દાખલ કરો",
  CardSuspenseCreditAccount: "કાર્ડ સસ્પેન્સ ક્રેડિટ ખાતું",
  EnterCardSuspenseCreditAccount: "કાર્ડ સસ્પેન્સ ક્રેડિટ ખાતું દાખલ કરો",
  CardSuspenseDebitAccount: "કાર્ડ સસ્પેન્સ ડેબિટ ખાતું",
  EnterCardSuspenseDebitAccount: "કાર્ડ સસ્પેન્સ ડેબિટ ખાતું દાખલ કરો",

  FinacleTransactionParticulars: "ફિનાકલ ટ્રાન્ઝેક્શનની વિગતો",
  FinacleTransactionParticulars2: "ફિનાકલ ટ્રાન્ઝેક્શનની વિગતો 2",
  AbabilTransactionParticulars: "અબાબીલ ટ્રાન્ઝેક્શનની વિગતો",
  AbabilTransactionParticulars2: "અબાબીલ ટ્રાન્ઝેક્શનની વિગતો 2",
  TranzwareTransactionParticulars: "ટ્રાન્ઝવેર ટ્રાન્ઝેક્શન વિગતો",
  TranzwareTransactionParticulars2: "ટ્રાન્ઝવેર ટ્રાન્ઝેક્શન વિગતો 2",
  DynamicKeyword: "ડાયનેમિક કીવર્ડ",
  TransactionParticularsfor: "માટે ટ્રાન્ઝેક્શન વિગતો",
  Finacle: "ફિનાકલ",
  Ababil: "અબાબીલ",
  Tranzware: "ટ્રાન્ઝવેર",
  AmountLabelMapping: "રકમ લેબલ મેપિંગ",
  AmountLabelReq: "રકમ લેબલ*",
  AmountLabelisAlreadyenteredatLine: "રકમનું લેબલ પહેલેથી જ ",
  Line: " લાઇન પર દાખલ કરેલ છે",

  ServiceWiseConfigurationConfirmation: "સેવા મુજબની રૂપરેખાંકન  પુષ્ટિ",
  ServiceWiseConfirmation: "સેવા મુજબની પુષ્ટિ",

  FinacleAsFromSource: "ફિનાકલ એઝ ફ્રોમ સોર્સ",
  AbabilAsFromSource: "અબાબીલ એઝ ફ્રોમ સોર્સ",
  TranzwareAsFromSource: "ટ્રાન્ઝવેર એઝ ફ્રોમ સોર્સ",

  //  Leaves Master

  LeavesMaster: "માસ્ટર છોડે છે",
  Template: "ટેમ્પલેટ",
  DeactiveDate: "નિષ્ક્રિય તારીખ",
  EnteredBy: "દ્વારા દાખલ",
  EnteredDate: "દાખલ કરેલ તારીખ",
  MachineName: "મશીનનું નામ",
  LastModifiedBy: "દ્વારા છેલ્લે સંશોધિત",
  LastMachinename: "છેલ્લું મશીન નામ",
  EnteraTemplate: "ટેમ્પલેટ દાખલ કરો",
  NumberofLeaves: "છોડનારની સંખ્યા*",
  EnterNumberofLeaves: "છોડનારની સંખ્યા દાખલ કરો",
  NumberofLeavesisAlreadyenteredatLine:
    "છોડનારની સંખ્યા પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",

  //Service Charge Template

  EffectiveDate: "અસરકારક તારીખ",
  LastEnteredBy: "છેલ્લે દાખલ કરેલ",
  LastEnteredDate: "છેલ્લી દાખલ તારીખ",
  LastModifiedDate: "છેલ્લી સંશોધિત તારીખ",
  ServiceChargeTemplateConfirmation: "સેવા ચાર્જ ટેમ્પલેટ પુષ્ટિ",
  ServiceChargeTemplateConfiguration: "સર્વિસ ચાર્જ ટેમ્પલેટ રૂપરેખાંકન ",
  FromAmount: "રકમ માંથી*",
  ToAmount: "રકમ સુધી*",
  ChargeAmountReq: "ચાર્જની રકમ*",
  ChargePercent: "ચાર્જની ટકાવારી",
  Compute: "ગણતરી*",
  Computes: "ગણતરી",
  FromAmountshouldbelessthenToAmount: "રકમ માંથી રકમથી ઓછી હોવી જોઈએ",
  FromAmountShouldBeGreaterThanPreviousToAmountOnSameDate:
    "થી રકમ અગાઉની રકમ કરતા વધારે હોવી જોઈએ",
  ToAmountshouldbegreaterthanFromAmount: "રકમ પ્રતિ રકમ કરતાં મોટી હોવી જોઈએ",

  //Holiday/Business Day Configuration
  HolidayBusinessDayConfiguration: "રજા/વ્યવસાય દિવસનું રૂપરેખાંકન ",
  StartDate: "પ્રારંભ તારીખ",
  EndDate: "સમાપ્તિ તારીખ",
  HolidayConfiguration: "રજા રૂપરેખાંકન ",
  EndDateshouldbegreaterthanStartDate:
    "'સમાપ્તિ તારીખ' 'પ્રારંભ તારીખ' કરતાં મોટી હોવી જોઈએ.",
  InvaliddaterangeEndDateshouldbegreaterthanStartDate:
    "અમાન્ય તારીખ શ્રેણી. 'સમાપ્તિ તારીખ' 'પ્રારંભ તારીખ' કરતાં મોટી હોવી જોઈએ.",
  Holidays: "રજાઓ",

  BusinessDayConfig: "વ્યવસાય દિવસ રૂપરેખા",
  Note: "નોંધ :",
  Note1:
    "વ્યવસાયિક દિવસો પહેલેથી જ જનરેટ કરવામાં આવ્યા છે. તમે ચેક ઇન કરી શકો છો વ્યવસાયિક દિવસો રૂપરેખાંકન  સ્ક્રીન.",
  Note2:
    "વ્યવસાયિક દિવસો જનરેટ કરવા માટે 'પોપ્યુલેટ વ્યવસાયિક દિવસો' બટન પર ક્લિક કરો.",
  BranchNameReq: "શાખાનું નામ*",
  HolidayConfig: "રજા રૂપરેખા",
  BusinessDayConfiguration: "વ્યાપાર દિવસ રૂપરેખાંકન ",
  Date: "તારીખ",
  DayName: "દિવસનું નામ",
  BusinessDayHoliday: "વ્યવસાય દિવસ / રજા",
  ThisValuealreadyexists: "આ મૂલ્ય પહેલેથી જ અસ્તિત્વમાં છે",
  Entervaliddate: "માન્ય તારીખ દાખલ કરો",
  Dateshould: "ની વચ્ચે હોવી જોઈએ",
  Dateshouldbebetween: "તારીખ {0} ની વચ્ચે હોવી જોઈએ",
  HolidayDate: "રજાની તારીખ*",
  HolidayDescription: "રજા વર્ણન*",
  HolidayType: "રજાનો પ્રકાર*",
  BranchNameisAlreadyenteredatLine:
    "શાખાનું નામ પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",
  // SelectBranchName: "શાખાનું નામ પસંદ કરો",

  //Scheme Master
  SchemeMaster: "યોજના માસ્ટર",
  SchemeCode: "યોજનાનો કોડ",
  ParentType: "પેરેન્ટ ટાઇપ",
  EnterParentType: "પેરેન્ટ ટાઈપ દાખલ કરો",
  SchemeMasterConfirmation: "યોજના માસ્ટર પુષ્ટિ",
  LeavesTemplate: "લીવ્ઝ ટેમ્પલેટ",
  Charges: "ચાર્જીસ",
  Service: "સેવા*",
  EnterSchemeCode: "યોજના કોડ દાખલ કરો",
  Populate: "વસવાટ કરો",

  // Operator Masters

  OperatorMasterconfirmation: "ઓપરેટર માસ્ટર પુષ્ટિ",
  OperatorMaster: "ઓપરેટર માસ્ટર",
  OperatorType: "ઓપરેટર પ્રકાર",
  OperatorID: "ઓપરેટર આઈડી",
  EnterOperatorID: "ઓપરેટર આઈડી દાખલ કરો",
  OperatorName: "ઓપરેટરનું નામ",
  EnterOperatorName: "ઓપરેટરનું નામ દાખલ કરો",
  UPLOADVIEWImage: "છબી અપલોડ કરો/જુઓ",

  TrnParticulars: "વ્યવહાર વિગત",
  EnterTrnParticulars: "વ્યવહાર વિગત દાખલ કરો.",
  TrnParticulars2: "વ્યવહાર વિગત2",
  EnterTrnParticulars2: "વ્યવહાર વિગત2 દાખલ કરો.",
  ChargeTemplate: "ચાર્જ નમૂનો",
  SpecialAmount: "ખાસ રકમ",
  AmountLabelAlreadyenteredatLine:
    "રકમ લેબલ પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",
  AccountNumber: "ખાતા નંબર",
  EnterAccountNumber: "ખાતા નંબર દાખલ કરો",
  MaximumAmountshouldbeGreaterthanorequaltoMinimumAmount:
    "મહત્તમ રકમ લઘુત્તમ રકમ કરતાં મોટી અથવા તેની બરાબર હોવી જોઈએ.",
  MinimumAmountshouldbeLessthanorequalToMaximumAmount:
    "લઘુત્તમ રકમ મહત્તમ રકમ કરતાં ઓછી અથવા તેની બરાબર હોવી જોઈએ.",
  Doubleclicktochangetheimage: "છબી બદલવા માટે બે વાર ક્લિક કરો",
  OptionisAlreadyenteredatLine: "વિકલ્પ પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",
  OptionType: "વિકલ્પનો પ્રકાર*",
  OperatorIcon: "ઓપરેટર ચિહ્ન",
  Uptosixrowsareallowedtobeadded: "છ પંક્તિઓ સુધી ઉમેરવાની મંજૂરી છે.",
  VIEWImage: "છબી જુઓ",

  // Source Parent Type Master

  SourceParentTypeMaster: "સ્ત્રોત પેરેન્ટ ટાઈપ માસ્ટર",
  SourceName: "સ્ત્રોતનું નામ",
  SourceType: "સ્ત્રોત પ્રકાર",
  EnterSourceType: "સ્ત્રોત પ્રકાર દાખલ કરો",
  DisplayOrder: "પ્રદર્શન ક્રમ",
  EnterDisplayOrder: "પ્રદર્શન ઓર્ડર દાખલ કરો",
  SignUpAllow: "સાઇન અપ કરો",
  BeneficiaryAllow: "લાભાર્થીને મંજૂરી આપો",

  //Insurance Master
  InsuranceMaster: "વીમા માસ્ટર",
  Code: "કોડ",
  EnterCode: "કોડ દાખલ કરો",
  AccountSource: "ખાતા સ્ત્રોત",
  EnterTransactionParticulars: "વ્યવહારની વિગતો દાખલ કરો",
  TransactionParticulars2: "વ્યવહારની વિગતો2",
  EnterTransactionParticulars2: "ટ્રાન્ઝેક્શન વિગતો દાખલ કરો2",
  Remark: "રિમાર્ક",
  EnterRemark: "રિમાર્ક દાખલ કરો",
  PolicyLabelEnglish: "પોલિસી લેબલ (અંગ્રેજી)",
  EnterPolicyLabelEnglish: "પોલિસી લેબલ દાખલ કરો (અંગ્રેજી)",
  PolicyLabelLocal: "પોલિસી લેબલ(સ્થાનિક)",
  EnterPolicyLabelLocal: "પોલિસી લેબલ દાખલ કરો (સ્થાનિક)",

  // University Master
  UniversityMaster: "યુનિવર્સિટી માસ્ટર",
  PaymentID: "ચુકવણી ID*",
  EnterPaymentID: "ચુકવણી ID દાખલ કરો",
  PaymentHeader: "ચુકવણી હેડર*",
  EnterPaymentHeader: "ચુકવણી હેડર દાખલ કરો",

  // Utility Master

  UtilityMaster: "ઉપયોગિતા માસ્ટર",

  // Club Master
  ClubMaster: "ક્લબ માસ્ટર",
  MemberDetails: "સભ્યોની વિગતો",
  DownloadSample: "ડાઉનલોડ નમૂના",
  UploadFile: "ફાઈલ અપલોડ કરો",
  Upload: "અપલોડ",
  ClubMemberDetail: "ક્લબ સભ્ય વિગતો",
  ClubMemberDetails: "ક્લબ સભ્ય વિગતો",
  MemberID: "સભ્ય આઈડી",
  EnterMemberID: "સભ્ય ID દાખલ કરો",
  MemberName: "સભ્યનું નામ",
  EnterMemberName: "સભ્યનું નામ દાખલ કરો",
  MemberType: "સભ્ય પ્રકાર",
  EnterMemberType: "સભ્ય પ્રકાર દાખલ કરો",
  MemberSince: "ત્યારથી સભ્ય",
  MemberStatus: "સભ્ય સ્થિતિ",
  EnterMemberStatus: "સભ્ય સ્થિતિ દાખલ કરો",
  EntryDate: "પ્રવેશ તારીખ",
  ClubMember: "ક્લબના સભ્ય",
  Futuredatesarenotallowed: "ભવિષ્યની તારીખોને મંજૂરી નથી.",
  InvalidDateareNotAllowedinMemberSinceColumn:
    "કૉલમથી સભ્યમાં અમાન્ય તારીખની મંજૂરી નથી",
  FutureDateareNotAllowedinMemberSinceColumn:
    "કૉલમથી સભ્યમાં ભાવિ તારીખની મંજૂરી નથી",
  Requiredfieldscannotbenull: "જરૂરી ફીલ્ડ્સ શૂન્ય હોઈ શકે નહીં",
  DoyouwanttoUpdateClubMemberData:
    "શું તમે ક્લબ મેમ્બર ડેટા અપડેટ કરવા માંગો છો?",
  Whichformatdoyouwanttodownload: "તમે કયું ફોર્મેટ ડાઉનલોડ કરવા માંગો છો?",
  Excel: "એક્સેલ",
  CSV: "સીએસવી",

  //Branch Master

  BranchMaster: "શાખા માસ્ટર",
  BranchCode: "શાખા કોડ",
  Address: "સરનામું",
  ContactNumber: "સંપર્ક નંબર",
  EmailID: "ઈમેલ આઈડી",
  EnterEmailID: "ઈમેલ આઈડી દાખલ કરો",
  FileDownload: "ફાઇલ ડાઉનલોડ કરો",

  ContactPerson: "વ્યક્તિનો સંપર્ક કરો",
  EnterContactPerson: "વ્યક્તિનો સંપર્ક દાખલ કરો",
  ContactPersonBranchManagerDetails: "વ્યક્તિ/શાખા મેનેજરની વિગતોનો સંપર્ક કરો",
  PayOrderAllow: "પે ઓર્ડર મંજૂરી આપો",
  ChequeBookAllow: "ચેક બુક મંજૂરી આપો",
  DPSAllow: "ડીપીએસ મંજૂરી આપો",
  FDAllow: "એફડી મંજૂરી આપો",
  District: "જિલ્લો",
  EnterAddress: "સરનામું દાખલ કરો",
  Longitude: "રેખાંશ",
  EnterLongitude: "રેખાંશ દાખલ કરો",
  Latitude: "અક્ષાંશ",
  EnterLatitude: "અક્ષાંશ દાખલ કરો",
  Phone1: "ફોન(1)",
  EnterPhone1: "ફોન દાખલ કરો(1)",
  Phone2: "ફોન(2)",
  EnterPhone2: "ફોન દાખલ કરો(2)",
  EMailisinvalid: "ઈ-મેલ અમાન્ય છે.",
  OpenDate: "તારીખ ખોલો",
  BranchName: "શાખાનું નામ",
  EnterBranchName: "શાખાનું નામ દાખલ કરો",
  EnterBranchCode: "શાખા કોડ દાખલ કરો",
  Norowsfoundforupdate: "અપડેટ કરવા માટે કોઈ પંક્તિઓ મળી નથી",
  DoyouwanttoUpdateBranchMasterData:
    "શું તમે બ્રાન્ચ માસ્ટર ડેટા અપડેટ કરવા માંગો છો?",
  MobileNumber: "મોબાઇલ નંબર",
  EnterMobileNumber: "મોબાઇલ નંબર દાખલ કરો",

  //OTP SMS Configuration
  OTPSMSConfiguration: "OTP એસએમએસ રૂપરેખાંકન ",
  ActionCode: "ક્રિયા કોડ",
  EnterActionCode: "ક્રિયા કોડ દાખલ કરો",
  ActionDescription: "ક્રિયા વર્ણન",
  EnterActionDescription: "ક્રિયા વર્ણન દાખલ કરો",
  SMSText: "SMS લખાણ",
  EnterSMSText: "SMS લખાણ દાખલ કરો",

  //Tenure Type Configuration
  TenureTypeConfiguration: "મુદત પ્રકાર રૂપરેખાંકન ",
  AccountType: "ખાતાનો પ્રકાર",
  TransactionTypeDisplay: "વ્યવહાર પ્રકાર પ્રદર્શન",
  AccountTypesDisplay: "ખાતા પ્રકાર પ્રદર્શન",
  TenureTypeReq: "મુદતનો પ્રકાર*",
  TenureReq: "મુદત*",
  Tenures: "મુદત",
  EnterTenure: "મુદત દાખલ કરો",
  EffectiveFromReq: "થી અસરકારક*",

  //Email/SMS Template Configuration

  EmailSMSTemplateConfiguration: "ઈમેલ/એસએમએસ ટેમ્પલેટ રૂપરેખાંકન ",
  TranType: "ટ્રાન. પ્રકાર",
  EnterTranType: "ટ્રાન. પ્રકાર દાખલ કરો",
  MailSubject: "મેઇલ નો વિષય",
  EnterMailSubject: "મેઇલ નો વિષય દાખલ કરો",
  SenderMailID: "મોકલનાર ઈ-મેલ આઈડી",
  EnterSenderMailID: "મોકલનાર ની ઈ-મેલ આઈડી",
  CCMailID: "સીસી મેઈલ આઈડી",
  EnterCCMailID: "સીસી મેઇલ આઈડી દાખલ કરો",
  DisplaySenderName: "મોકલનાર નું નામ દર્શાવો",
  EnterDisplaySenderName: "પ્રદર્શિત મોકલનાર નું નામ દાખલ કરો",
  MailServer: "મેઇલ સર્વર",
  SMS: "એસએમએસ",
  Email: "ઈમેલ",
  SorrythecontentyouaretryingtouploadmustbeinHTMLformat:
    "માફ કરશો, તમે જે સામગ્રી અપલોડ કરવાનો પ્રયાસ કરી રહ્યાં છો તે HTML ફોર્મેટમાં હોવું આવશ્યક છે.",
  EmailConfiguration: "ઇમેઇલ રૂપરેખાંકન ",
  Import: "આયાત કરો",
  EmailText: "ઈમેઈલ લખાણ",
  EnterEmailText: "ઈમેઈલ લખાણ દાખલ કરો",
  Keys: "કીઓ",
  NoteImportHTMLFile:
    "નોંધ: HTML ફાઇલને આયાત કરવા માટે, કાં તો તેને ઈમેઈલ ટેક્સ્ટ બોક્સમાં ખેંચો અને છોડો અથવા ઉપરના 'આયાત કરો' બટનને ક્લિક કરો.",
  InvalidMailSenderMailID: "અમાન્ય મેઇલ મોકલનાર નું મેઇલ આઈડી.",
  SMSConfiguration: "એસએમએસ રૂપરેખાંકન ",

  //Beneficiary Restriction Master
  BeneficiaryRestrictionMaster: "લાભાર્થી પ્રતિબંધ રૂપરેખાંકન",
  RestrictionType: "પ્રતિબંધનો પ્રકાર",
  Value: "મૂલ્ય",
  BeneficiaryLabel: "લાભાર્થીનું લેબલ",
  AccountName: "ખાતાનું નામ",
  EnterAccountName: "ખાતાનું નામ દાખલ કરો",
  ProductCode: "પ્રોડક્ટ કોડ",
  EnterProductCode: "પ્રોડક્ટ કોડ દાખલ કરો",
  RoutingNumber: "રાઉટીંગ નંબર",
  EnterRoutingNumber: "રાઉટીંગ નંબર દાખલ કરો",
  RecordAlreadyExists: "રેકોર્ડ પહેલેથી જ અસ્તિત્વમાં છે.",

  // ATM Locator Master
  ATMLocatorMaster: "એટીએમ લોકેટર માસ્ટર",
  ATMLocation: "એટીએમનું સ્થાન",
  EnterATMLocation: "એટીએમનું સ્થાન દાખલ કરો",
  Address1: "સરનામું 1",
  EnterAddress1: "સરનામું 1 દાખલ કરો",
  Address2: "સરનામું 2",
  EnterAddress2: "સરનામું 2 દાખલ કરો",
  Address3: "સરનામું 3",
  EnterAddress3: "સરનામું 3 દાખલ કરો",
  PostalCode: "ટપાલ કોડ",
  EnterPostalCode: "ટપાલ કોડ દાખલ કરો",
  ActiveStatus: "સક્રિય સ્થિતિ",
  DoyouwanttoupdateATMLocatormasterdata:
    "શું તમે એટીએમ લોકેટર માસ્ટર ડેટા અપડેટ કરવા માંગો છો?",

  //Screen Note Configuration
  ScreenNoteConfiguration: "સ્ક્રીન નોંધ રૂપરેખાંકન ",
  ScreenID: "સ્ક્રીન આઈડી",
  EnglishNote: "અંગ્રેજી નોંધ",
  BanglaNote: "બાંગ્લા નોંધ",
  English: "અંગ્રેજી*",
  EnterEnglishMessage: "અંગ્રેજી સંદેશ દાખલ કરો",
  Bangla: "બાંગ્લા",
  EnterBanglaMessage: "બાંગ્લા સંદેશ દાખલ કરો",
  Translate: "અનુવાદ કરો",

  //Guessable Password Entry
  GuessablePasswordEntry: "અનુમાનિત પાસવર્ડ એન્ટ્રી",
  GuessablePassword: "અનુમાનિત પાસવર્ડ",
  EnterGuessablePassword: "અનુમાનિત પાસવર્ડ દાખલ કરો",

  //Banner Configuration

  BannerConfiguration: "બેનર રૂપરેખાંકન ",
  BannerType: "બેનરનો પ્રકાર",
  BannerDescription: "બેનર વર્ણન",
  LoginID: "લૉગિન આઈડી",
  EnterLoginID: "લૉગિન આઈડી દાખલ કરો",
  ChannelReq: "ચેનલ*",
  Invaliddate: "અમાન્ય તારીખ",
  ViewUploadHTML: "HTML જુઓ/અપલોડ કરો",
  Htmltext: "HTML લખાણ",
  EnterHtmltext: "HTML લખાણ દાખલ કરો",
  BannerNote:
    "નોંધ: HTML ફાઇલને આયાત કરવા માટે, કાં તો તેને ઈમેઈલ ટેક્સ્ટ બોક્સમાં ખેંચો અને છોડો અથવા ઉપરના 'આયાત કરો' બટનને ક્લિક કરો.",
  DropHere: "અહીં છોડો",
  DropHTMLFileHere: "HTML ફાઈલ અહીં મૂકો",
  DisplayType: "પ્રદર્શનનો પ્રકાર",
  InvalidLoginID: "અમાન્ય લૉગિન ID.",

  //Guideline File Configuration
  GuidelineFileConfiguration: "માર્ગદર્શિકા ફાઇલ રૂપરેખાંકન ",
  UseCase: "કેસ વાપરો",
  UploadDate: "અપલોડ તારીખ",
  FileName: "ફાઈલનું નામ",
  EnterFileName: "ફાઈલનું નામ દાખલ કરો",
  FileType: "ફાઈલનો પ્રકાર",
  Filesizeshouldbelessthan5MB: "ફાઇલનું કદ 5 MB કરતા ઓછું હોવું જોઈએ.",
  PleaseSelectPDFFileonly: "કૃપા કરીને ફક્ત PDF ફાઇલ પસંદ કરો.",
  Nofilefoundtopreview: "પૂર્વાવલોકન કરવા માટે કોઈ ફાઇલ મળી નથી!",

  // FD Scheme Configuration
  FDSchemeConfiguration: "FD યોજના રૂપરેખાંકન ",
  FDAccounttype: "FD ખાતાનો પ્રકાર",
  TenureTypeFinacle: "મુદત નો પ્રકાર ફિનાકલ",
  Tenure: "મુદત",
  Renewal: "નવીકરણ",
  EnterRenewal: "નવીકરણ દાખલ કરો",
  MaturityInst: "પરિપક્વતા સંસ્થા.",
  EnterMaturityInst: "પરિપક્વતા સંસ્થા દાખલ કરો",
  NatureofAccount: "ખાતાની પ્રકૃતિ",
  EnterNatureofAccount: "ખાતાની પ્રકૃતિ દાખલ કરો",
  TenureTypeRate: "મુદત નો પ્રકાર દર",
  EnterTenureTypeRate: "મુદત નો પ્રકાર દર દાખલ કરો",
  CCY: "સીસીવાય",
  EnterCCY: "સીસીવાય દાખલ કરો",
  SchemeDescription: "યોજના વર્ણન",
  EnterSchemeDescription: "યોજના વર્ણન દાખલ કરો",
  TDModAmount: "ટીડી મોડની રકમ",
  EnterTDModAmount: "ટીડી મોડની રકમ દાખલ કરો",
  SampleFileDownload: "નમૂના ફાઇલ ડાઉનલોડ કરો",
  FdAccountType: "એફડી ખાતાનો પ્રકાર",
  EnterFdAccountType: "એફડી ખાતાનો પ્રકાર દાખલ કરો",
  DoyouwanttoUpdateFDSchemeMasterData:
    "શું તમે FD સ્કીમ માસ્ટર ડેટા અપડેટ કરવા માંગો છો?",
  FDSchemeMaster: "FD યોજના માસ્ટર",

  //Parameter Master
  Parameter: "પરિમાણ",
  ParameterMaster: "પરિમાણ માસ્ટર",
  DataType: "માહિતી પ્રકાર",
  GlobalLevel: "વૈશ્વિક સ્તર",
  HOLevel: "HO સ્તર",
  EnterValue: "મૂલ્ય દાખલ કરો",
  ParameterConfirmation: "પરિમાણ પુષ્ટિ",
  NewParameterValue: "નવું પરિમાણ મૂલ્ય",
  OldParameterValue: "જૂનું પરિમાણ મૂલ્ય",
  NewDatatype: "નવો ડેટા પ્રકાર",
  OldDatatype: "જૂનો ડેટા પ્રકાર",

  //Miscellaneous Master
  MiscellaneousMaster: "પરચુરણ માસ્ટર",
  CategoryCode: "શ્રેણી કોડ",
  EnterCategoryCode: "શ્રેણી કોડ દાખલ કરો",
  DataValue: "માહિતી મૂલ્ય",
  EnterDataValue: "માહિતી મૂલ્ય દાખલ કરો",
  DisplayValue: "પ્રદર્શન મૂલ્ય",
  EnterDisplayValue: "પ્રદર્શન મૂલ્ય દાખલ કરો",

  //User Block Configuration
  UserBlockConfiguration: "વપરાશકર્તા બ્લોક રૂપરેખાંકન ",
  ConfigType: "રૂપરેખા પ્રકાર",
  FailAttempt: "નિષ્ફળ પ્રયાસ",
  MinutesOfBlock: "બ્લોકની મિનિટો",
  EnterMinutesOfBlock: "બ્લોકની મિનિટો દાખલ કરો",
  AutoRelease: "ઓટો રીલીઝ",
  EnterNoOfFailAttempt: "નિષ્ફળ પ્રયાસની સંખ્યા દાખલ કરો",
  OldFailAttempt: "જૂનો નિષ્ફળ પ્રયાસ",
  OldMinutesOfBlock: "બ્લોકની જૂની મિનિટ",
  UserBlockConfigurationConfirmation: "વપરાશકર્તા બ્લોક રૂપરેખાંકન પુષ્ટિ",

  //Application Review User Master
  ApplicationReviewUserMaster: "એપ્લિકેશન સમીક્ષા વપરાશકર્તા માસ્ટર",
  LoginName: "લોગીન નામ",
  TestLoginID: "પરીક્ષણ લોગિન આઈડી",
  ReviewLoginName: "લોગીન નામની સમીક્ષા કરો",
  LatestVersion: "નવીનતમ સંસ્કરણ",
  EnterLatestAppVersion: "નવીનતમ એપ્લિકેશન સંસ્કરણ દાખલ કરો",
  ExpiryDate: "અંતિમ તારીખ",
  TestUserLastLoginDate: "પરીક્ષણ વપરાશકર્તાની છેલ્લી લોગીન તારીખ",
  EnterTestLoginID: "ટેસ્ટ લોગિન આઈડી દાખલ કરો",
  EnterReviewLoginName: "રિવ્યૂ લોગિન નામ દાખલ કરો",
  EnterLatestVersion: "નવીનતમ સંસ્કરણ દાખલ કરો",
  Spaceatthebeginningisnotallowed: "શરૂઆતમાં જગ્યા મંજૂર નથી.",
  EnteraproperMobileAppVersion: "યોગ્ય મોબાઇલ એપ્લિકેશન સંસ્કરણ દાખલ કરો.",
  Pastdateisnotallowed: "પાછલી તારીખની મંજૂરી નથી.",
  EnterTestUserLastLoginDate: "ટેસ્ટ વપરાશકર્તાની છેલ્લી લૉગિન તારીખ દાખલ કરો",

  //Validation Message Master
  ValidationMessageMaster: "માન્યતા સંદેશ માસ્ટર",
  MessageCode: "સંદેશ કોડ",
  EnglishMessage: "અંગ્રેજી સંદેશ",
  BanglaMessage: "બાંગ્લા સંદેશ",
  EnglishLan: "અંગ્રેજી",

  //Card BIN Image Configuration
  CardBINImageConfiguration: "કાર્ડ BIN છબી રૂપરેખાંકન",
  CardBin: "કાર્ડ બિન",
  AllowBanglaQR: "બાંગ્લા QR ને મંજૂરી આપો",
  CardImage: "કાર્ડ છબી",
  UserStatus: "વપરાશકર્તા સ્થિતિ",
  CardBinImageUpload: "કાર્ડ બિન છબી અપલોડ",
  CardBinNumber: "કાર્ડ બિન નંબર",
  EnterCardBinNumber: "કાર્ડ બિન નંબર દાખલ કરો",
  Imagesizeshouldbelessthan5MB: "છબીનું કદ 5 MB કરતા ઓછું હોવું જોઈએ.",
  PleaseSelectValidFormat: "કૃપા કરીને માન્ય ફોર્મેટ પસંદ કરો.",
  ClicktouploadtheCardImage: "કાર્ડ ઈમેજ અપલોડ કરવા માટે ક્લિક કરો",
  UploadCardImage: "અપલોડ કાર્ડ છબી",
  ClickontheCardImageboxtouploadImage:
    "ઈમેજ અપલોડ કરવા માટે કાર્ડ ઈમેજ બોક્સ પર ક્લિક કરો.",
  MaximumImageSizeshouldbe5MB: "છબીનું મહત્તમ કદ 5 MB હોવું જોઈએ.",
  ImageformatshouldbeJPEGorPNG: "છબીનું ફોર્મેટ JPEG અથવા PNG હોવું જોઈએ.",

  // MS Monitoring Master

  MSMonitoringMaster: "એમએસ મોનીટરીંગ માસ્ટર",
  ServiceID: "સેવા આઈડી",
  ActiveInstance: "સક્રિય દાખલો",
  MSInstanceInformations: "એમએસ દાખલાની માહિતી",
  InstanceID: "દાખલો આઈડી",
  PropertiesList: "ગુણધર્મો યાદી",
  Properties: "ગુણધર્મો",
  MicroServiceList: "સૂક્ષ્મ સેવાઓની સૂચિ",
  InstanceStatus: "દાખલાની સ્થિતિ",
  UpdateStatus: "સ્થિતિ અપડેટ કરો",
  APIResponse: "API પ્રતિભાવ",

  //Service wise Mobile Number Validation Template Mapping
  ServiceWiseMobileNumberValidationMaster:
    "સેવા મુજબ મોબાઇલ નંબર માન્યતા માસ્ટર",
  TemplateName: "નમૂનાનું નામ",
  ServiceWiseMobileNumberValidationConfirmation:
    "સેવા મુજબ મોબાઇલ નંબર માન્યતા પુષ્ટિ",

  //IDTP Charge Configuration

  IDTPChargeConfiguration: "IDTP ચાર્જ રૂપરેખાંકન",
  ReceiverFI: "પ્રાપ્ત કરનાર ફિ*",
  IDTPChargeConfigurationConfirmation: "IDTP ચાર્જ રૂપરેખાંકન પુષ્ટિ",
  NewServiceChargeTemplate: "નવો સર્વિસ ચાર્જ નમૂનો",
  OldServiceChargeTemplate: "જૂનો સેવા ચાર્જ નમૂનો",
  NewVATPercentage: "નવી VAT ટકાવારી",
  OldVATPercentage: "જૂની VAT ટકાવારી",

  //Service Monitoring Master
  ServiceMonitoringMaster: "સેવા મોનીટરીંગ માસ્ટર",
  LastExecutionDate: "છેલ્લી અમલ તારીખ",

  //MS Service Message Configuration
  MSServiceMessageConfiguration: "એમએસ સંદેશ રૂપરેખાંકન",
  KeyName: "કી નામ",
  EnterKeyName: "કી નામ દાખલ કરો",
  DefaultMessage: "મૂળભૂત સંદેશ",
  EnterDefaultMessage: "મૂળભૂત સંદેશ દાખલ કરો",
  LocalLanguageMessage: "સ્થાનિક ભાષા સંદેશ",
  EnterLocalLanguageMessage: "સ્થાનિક ભાષા સંદેશ દાખલ કરો",
  Orderby: "દ્વારા ઓર્ડર",
  Comments: "ટિપ્પણીઓ",

  //MS Properties Configuration
  MSPropertiesConfiguration: "એમએસ ગુણધર્મો રૂપરેખાંકન",
  ApplicationName: "અરજીનું નામ",
  ProfileName: "પ્રોફાઇલનું નામ",
  Label: "લેબલ",
  AreyousuretodeleteselectedMobileNumberValidationTemplate:
    "શું તમે પસંદ કરેલ મોબાઇલ નંબર માન્યતા નમૂનાને કાઢી નાખવાની ખાતરી કરો છો?",
  Key: "કી",
  EnterKey: "કી દાખલ કરો",
  NoteOne: "1. *-કી મૂલ્યને * સુધી લંબાઈ સાથે બદલો. EX.ACCOUNT=*{' '}",
  NoteTwo:
    "2. જો ખાલી હોય તો કી વેલ્યુને ખાલી સ્ટ્રિંગથી બદલો. EX.accountNumber={' '}",
  NoteThree:
    "3. જો ફોર્મેટ સ્પષ્ટ કરેલ હોય તો સિસ્ટમ આપેલ ફોર્મેટ મુજબ ફોર્મેટ અને માસ્ક કરેલ મૂલ્ય સાથે મેળ ખાશે પરંતુ ફોર્મેટની લંબાઈ કી મૂલ્ય લંબાઈ જેટલી જ હોવી જોઈએ. જો ફોર્મેટ મૂલ્યની લંબાઈ સાથે મેળ ખાતું નથી, તો કોઈ માસ્કિંગ કરશે નહીં. EX.$[1234******123,1234******123578]{''}",
  NoteFour:
    "4. જો અહીં ઉલ્લેખિત કી નામ JSON ઑબ્જેક્ટ/JSON એરે તરીકે મૂલ્યો ધરાવે છે, તો મૂલ્ય '''' સાથે બદલવામાં આવશે.'{' '}",

  // Virtual Card Image Configuration
  CardImageConfiguration: "કાર્ડ છબી રૂપરેખાંકન",
  CardImageConfirmation: "કાર્ડ છબી રૂપરેખાંકન પુષ્ટિ",
  ImageID: "છબી આઈડી",
  EnterImageID: "છબી આઈડી દાખલ કરો",
  CardImageUpload: "કાર્ડ છબી અપલોડ",

  //Web Rerouting Configuration
  WebReroutingConfiguration: "વેબ રીરૂટિંગ રૂપરેખાંકન",
  ActionMenu: "ક્રિયા મેનૂ",
  PopupStatus: "પોપઅપ સ્થિતિ",
  LoginStatus: "લૉગિન સ્થિતિ",
  LabelEnglish: "લેબલ (અંગ્રેજીમાં)",
  EnterEnglishLanguageLabel: "અંગ્રેજી ભાષાનું લેબલ દાખલ કરો",
  LabelLocalLanguage: "લેબલ (સ્થાનિક ભાષા)",
  EnterLocalLanguageLabel: "સ્થાનિક ભાષા લેબલ દાખલ કરો",
  PleaseentervalidURL: "કૃપા કરીને માન્ય URL દાખલ કરો.",
  PopupMessageEnglish: "પોપઅપ સંદેશ (અંગ્રેજી)",
  EnterEnglishLanguagePopupMessage: "અંગ્રેજી ભાષાનો પોપઅપ સંદેશ દાખલ કરો",
  PopupMessageLocalLanguage: "પોપઅપ સંદેશ (સ્થાનિક ભાષા)",
  EnterLocalLanguagePopupMessage: "સ્થાનિક ભાષા પોપઅપ સંદેશ દાખલ કરો",
  ServiceCode: "સેવા કોડ",
  EnterServiceCode: "સેવા કોડ દાખલ કરો",
  APIPassword: "API પાસવર્ડ",
  EnterAPIPassword: "API પાસવર્ડ દાખલ કરો",
  APIUserID: "API યુઝર આઈડી",
  EnterAPIUserID: "API યુઝર આઈડી દાખલ કરો",
  URL: "URL",
  EnterURL: "URL દાખલ કરો",
  WebReroutingConfirmation: "વેબ રીરૂટિંગ પુષ્ટિકરણ",
  MenuIcon: "મેનૂ ચિહ્ન",
  ClicktouploadtheMenuIcon: "મેનુ ચિહ્ન અપલોડ કરવા માટે ક્લિક કરો",
  UploadMenuIcon: "અપલોડ મેનૂ ચિહ્ન",
  ClickontheMenuIconboxtouploadIcon:
    "આઇકન અપલોડ કરવા માટે મેનુ આઇકોન બોક્સ પર ક્લિક કરો.",
  MaximumIconSizeshouldbe5MB: "મહત્તમ આઇકનનું કદ 5 MB હોવું જોઈએ.",
  IconformatshouldbeJPEGorPNG: "ચિહ્ન ફોર્મેટ JPEG અથવા PNG હોવું જોઈએ.",

  //Payment Gateway Merchant Master
  PaymentGatewayMerchantMaster: "ચુકવણી ગેટવે વેપારી માસ્ટર",
  PaymentGatewayMerchantNameReq: "ચુકવણી ગેટવે વેપારીનું નામ*",
  EnterPaymentGatewayMerchantName: "ચુકવણી ગેટવે વેપારીનું નામ દાખલ કરો",

  //Merchant Onboarding Confirmation
  MerchantOnboardingConfirmation: "વેપારી ઓનબોર્ડિંગની પુષ્ટિ",
  MerchantOnboardingConfiguration: "વેપારી ઓનબોર્ડિંગ રૂપરેખાંકન",
  GateWayPasswordValidation:
    "ગેટવે પાસવર્ડ આલ્ફાન્યૂમેરિક હોવો જોઈએ અને તેમાં ઓછામાં ઓછું એક ખાસ કેરેક્ટર,એક સ્મોલ કેરેક્ટર,એક કેપિટલ કેરેક્ટર તેની વચ્ચે કોઈ જગ્યા વગર હોવો જોઈએ.",
  PerTransactionLimit: "પ્રતિ વ્યવહાર મર્યાદા",
  EnterPerTransactionLimit: "પ્રતિ વ્યવહાર મર્યાદા દાખલ કરો",
  GatewayEmail: "ગેટવે ઈમેઈલ",
  EnterGatewayEmail: "ગેટવે ઇમેઇલ દાખલ કરો",
  InvalidMailGatewayEmail: "અમાન્ય મેઇલ ગેટવે ઇમેઇલ.",
  PercentageofVAT: "VAT ની ટકાવારી",
  EnterPercentageofVAT: "VATની ટકાવારી દાખલ કરો",
  ToAccountNumber: "ખાતા નંબર માટે",
  EnterToAccountNumber: "ખાતા નંબર દાખલ કરો",
  GatewayUsername: "ગેટવે વપરાશકર્તા નામ",
  GatewayPassword: "ગેટવે પાસવર્ડ",
  EnterGatewayPassword: "ગેટવે પાસવર્ડ દાખલ કરો",
  PleaseEnterURL: "કૃપા કરીને URL દાખલ કરો",

  //PGW Merchant Users
  PGWMerchantUsers: "PGW વેપારી વપરાશકર્તાઓ",
  UserRole: "વપરાશકર્તા ભૂમિકા",
  PGWMerchantUsersConfirmation: "PGW વેપારી વપરાશકર્તાઓ પુષ્ટિ",
  PGWMerchantUserCreation: "PGW મર્ચન્ટ યુઝર ક્રિએશન",
  GatewayNamePID: "ગેટવે નામ (PID)",
  PleaseentervalidIPAddress: "કૃપા કરીને માન્ય આઈપી સરનામું દાખલ કરો.",
  IPAddress: "આઈપી સરનામું",
  EnterIPAddress: "આઈપી સરનામું દાખલ કરો.",
  EmailIDisinvalid: "ઈમેલ આઈડી અમાન્ય છે",
  GatewayName: "ગેટવેનું નામ",
  ConfirmationStatus: "પુષ્ટિ સ્થિતિ",

  //Mobile Number Validation Template
  MobileNumberValidationTemplate: "મોબાઇલ નંબર માન્યતા નમૂનો",
  MobileNoLengthReq: "મોબાઈલ નંબર લંબાઈ*",
  EnterMobileNoLength: "મોબાઇલ નંબરની લંબાઈ દાખલ કરો",
  MobileNoStartFrom: "મોબાઈલ નંબર થી શરુ કરો",
  EnterMobileNoStartFrom: "મોબાઇલ નંબર દાખલ કરો. થી શરૂ કરો",
  DescriptionReq: "વર્ણન*",

  //Dynamic Biller Deletion Request Confirmation
  DynamicBillerDeletionRequestConfirmation:
    "ગતિશીલ બિલર કાઢી નાખવાની વિનંતીની પુષ્ટિ",
  DynamicBillerConfirmation: "ગતિશીલ બિલર પુષ્ટિ",
  DynamicBillerConfiguration: "ગતિશીલ બિલર રૂપરેખાંકન",
  CategoryID: "શ્રેણી આઈડી",
  EnterCategoryID: "શ્રેણી આઈડી દાખલ કરો",
  SubCategoryID: "પેટા શ્રેણી આઈડી",
  EnterSubCategoryID: "પેટા શ્રેણી આઈડી દાખલ કરો",
  BillerID: "બિલર આઈડી",
  EnterBillerID: "બિલર આઈડી દાખલ કરો",
  BilleName: "બિલરનું નામ",
  EnterBilleName: "બિલરનું નામ દાખલ કરો",
  SubCategoryName: "પેટા શ્રેણીનું નામ",
  CategoryName: "શ્રેણીનું નામ",
  BillerDescription: "બિલરનું વર્ણન",
  SubCategoryDescription: "પેટા શ્રેણી વર્ણન",
  CategoryDescription: "શ્રેણી વર્ણન",
  BillerInfoURL: "બિલર માહિતી URL",
  BillerPaymentURL: "બિલર ચુકવણી URL",
  Refresh: "તાજું કરો",
  ScreenNotes: "સ્ક્રીન નોંધો",
  FieldOptions: "ક્ષેત્ર વિકલ્પો",
  Options: "વિકલ્પો",
  BillerDetails: "બિલર વિગતો",
  Doyouwanttoupdateselectedbillerdata:
    "શું તમે પસંદ કરેલ બિલર ડેટા અપડેટ કરવા માંગો છો?",
  RefreshDynamicBillerConfiguration: "ગતિશીલ બિલર રૂપરેખાંકન તાજું કરો",
  DynamicBillerScreenNotes: "ગતિશીલ બિલર સ્ક્રીન નોંધો",
  Language: "ભાષા",
  ScreenMessage: "સ્ક્રીન સંદેશ",
  EnterScreenMessage: "સ્ક્રીન સંદેશ દાખલ કરો",
  FieldName: "ક્ષેત્રનું નામ",
  FieldType: "ક્ષેત્ર પ્રકાર",
  Required: "જરૂરી છે",
  Datatype: "ડેટા પ્રકાર",
  MinimumValue: "લઘુત્તમ મૂલ્ય",
  MaximumValue: "મહત્તમ મૂલ્ય",
  LabelEnglish1: "લેબલ અંગ્રેજી",
  LabelBangla: "લેબલ બાંગ્લા",
  DefaultValue: "મૂળભૂત મૂલ્ય",
  TextAlign: "લખાણ સંરેખિત કરો",
  Placeholder: "પ્લેસહોલ્ડર",
  ValidationRegex: "માન્યતા રેજેક્સ",
  IsBeneficiaryField: "લાભાર્થી ક્ષેત્ર છે",
  RequireForBillInfo: "બિલની માહિતી માટે જરૂરી છે",
  DisplaySequence: "પ્રદર્શિત ક્રમ",
  IspayableAmount: "ચૂકવવાપાત્ર રકમ છે",
  IsBillNumber: "બિલ નંબર છે",
  IsFromAccountField: "એકાઉન્ટ ફીલ્ડમાંથી છે",
  IsReadonlyField: "ફક્ત વાંચવા માટેનું ક્ષેત્ર છે",
  OptionsName: "વિકલ્પોનું નામ",
  OptionsValue: "વિકલ્પો મૂલ્ય",
  ParameterKeys: "પરિમાણ કીઓ",
  DynamicBillerURLs: "ગતિશીલ બિલર URLs",
  BillerFields: "બિલર ક્ષેત્રો",
  BillInfoParameters: "બિલ માહિતી પરિમાણો",
  BillPaymentParameters: "બિલ ચુકવણી પરિમાણો",
  BillerName: "બિલરનું નામ",
  DynamicBillerAccountsChargeConfirmation: "ગતિશીલ બિલર હિસાબ/ચાર્જ પુષ્ટિ",
  FinaclePoolAccount: "ફિનાકલ પૂલ ખાતું",
  EnterFinaclePoolAccount: "ફિનાકલ પૂલ ખાતું દાખલ કરો",
  AbabilPoolAccount: "અબાબીલ પૂલ ખાતું",
  EnterAbabilPoolAccount: "અબાબીલ પૂલ ખાતું દાખલ કરો",
  DynamicBillerChargeConfiguration: "ગતિશીલ બિલર ચાર્જ રૂપરેખાંકન",
  SubCategoryImage: "પેટા શ્રેણી છબી",
  BillerImage: "બિલર છબી",
  NoteDoubleclickontheImageboxtouploadanewImage:
    "નોંધ: નવી છબી અપલોડ કરવા માટે ઈમેજ બોક્સ પર બે વાર ક્લિક કરો.",

  //Bank Master
  BankMaster: "બેંક માસ્ટર",
  BankCode: "બેંક કોડ",
  EnterBankCode: "બેંક કોડ દાખલ કરો",
  NewDistrictCode: "નવો જિલ્લા કોડ",
  NPSBBankCode: "NPSB બેંક કોડ",
  EnterNPSBBankCode: "NPSB બેંક કોડ દાખલ કરો",
  BankName: "બેંકનું નામ",
  EnterBankName: "બેંકનું નામ દાખલ કરો",
  NPSB: "NPSB",
  BEFTN: "BEFTN",
  RTGS: "RTGS",
  ROWTYPE: "ROW TYPE",
  NPSBENABLED: "NPSB ENABLED",
  BEFTNENABLED: "BEFTN ENABLED",
  RTGSENABLED: "RTGS ENABLED",
  Pleaseselectrecords: "કૃપા કરીને રેકોર્ડ્સ પસંદ કરો.",
  Doyouwanttodeletetheselectedrecords:
    "શું તમે પસંદ કરેલા રેકોર્ડ્સ કાઢી નાખવા માંગો છો?",
  Pleaseselectoneusertogetthedetails:
    "કૃપા કરીને વિગતો મેળવવા માટે એક વપરાશકર્તા પસંદ કરો",
  UpdateServiceStatus: "સર્વિસ સ્ટેટસ અપડેટ કરો",
  BankServiceStatusTitle: "બેંક સેવા સ્થિતિ અપડેટ",
  BankServiceStatusCountNote: "પસંદ કરેલ બેંકો: ",
  BankServiceStatusNote:
    "નોંધ: કૃપા કરીને બધી પસંદ કરેલી બેંકોમાં અપડેટ કરવા માટે સેવા અને સ્થિતિ પસંદ કરો.",
  BankServiceStatusUpdateMsg:
    "શું તમે ખરેખર પસંદ કરેલી બધી બેંકોમાં {1} સેવા {0} કરવા માંગો છો?",
  DoyouwanttoUpdateBankMasterData:
    "શું તમે બેંક માસ્ટર ડેટા અપડેટ કરવા માંગો છો?",

  // MFS Configuration
  MFSConfiguration: "MFS રૂપરેખાંકન",
  MFSService: "MFS સેવા",
  MFSID: "MFS આઈડી",
  EnterMFSID: "MFS આઈડી દાખલ કરો",
  MFSName: "MFS નામ",
  EnterMFSName: "MFS નામ દાખલ કરો",
  MaximunDailyLimit: "મહત્તમ દૈનિક મર્યાદા",
  MFSLabelEnglish: "MFS લેબલ (અંગ્રેજી)",
  EnterMFSEnglishLanguageLabel: "MFS અંગ્રેજી ભાષાનું લેબલ દાખલ કરો",
  MFSLabelLocal: "MFS લેબલ (સ્થાનિક)",
  EnterMFSLocalLanguageLabel: "MFS સ્થાનિક ભાષાનું લેબલ દાખલ કરો",
  TranCode: "ટ્રાન કોડ",
  Perdaymaxaddmoneyinbeneficiary: "દિવસ દીઠ મહત્તમ લાભાર્થી નાણા ઉમેરો",
  EnterPerdaymaxaddmoneyinbeneficiary:
    "દિવસ દીઠ મહત્તમ લાભાર્થી નાણા ઉમેરો દાખલ કરો",
  MFSConfigurationConfirmation: "MFS રૂપરેખાંકન પુષ્ટિ",
  MFSIcon: "MFS ચિહ્ન",

  //From Source Key Value Configuration
  FromSourceKeyValueConfiguration: "સ્રોત કી મૂલ્ય રૂપરેખાંકન માંથી",
  Services: "સેવા",
  DescriptionisAlreadyenteredatLine: "વર્ણન પહેલાથી જ લાઇન {0} પર દાખલ કરેલ છે",
  AllowDisallowReq: "મંજૂરી આપો/નકારો*",
  ResponseKeyValue: "પ્રતિભાવ કી મૂલ્ય",
  ResponseKey: "પ્રતિભાવ કી",
  ResponseKeyValueReq: "પ્રતિભાવ કી મૂલ્ય*",
  EnterResponseKeyValue: "પ્રતિસાદ કી મૂલ્ય દાખલ કરો",

  //Card Activate/Deactivate Status Configuration
  CardActivateDeactivateStatusConfiguration:
    "કાર્ડ સક્રિય/નિષ્ક્રિય સ્થિતિ રૂપરેખાંકન",
  CardStatus: "કાર્ડ સ્થિતિ",
  OperationType: "ઓપરેશનનો પ્રકાર",
  StatusValue: "સ્થિતિ મૂલ્ય",
  EnterStatusValue: "સ્થિતિ મૂલ્ય દાખલ કરો",
  EnableStatusReq: "સ્થિતિ સક્ષમ કરો*",
  EnablestatusisAlreadyenteredatLine:
    "સક્ષમ સ્થિતિ પહેલેથી જ રેખા {0} પર દાખલ કરેલ છે",
  StatusValueReq: "સ્થિતિ મૂલ્ય*",
  StatusValueisAlreadyenteredatLine:
    "સ્થિતિ મૂલ્ય પહેલેથી જ રેખા {0} પર દાખલ કરેલ છે",

  // Product Display Name Configuration
  ProductDisplayNameConfiguration: "ઉત્પાદન પ્રદર્શન નામ રૂપરેખાંકન",
  DisplayName: "પ્રદર્શન નામ",
  Enterdisplayname: "પ્રદર્શન નામ દાખલ કરો",
  CompanyCode: "કંપની કોડ",
  SchemeCodeCardBINReq: "સ્કીમ કોડ/કાર્ડ BIN*",
  EnterschemecodeCarBINno: "સ્કીમ કોડ/કાર્ડ BIN નંબર દાખલ કરો.",
  SchemeCodeCardBINNoisAlreadyenteredatLine:
    "સ્કીમ કોડ/કાર્ડ BIN નંબર પહેલાથી જ લાઇન {0} પર દાખલ કરેલ છે",
  SchemeNameReq: "યોજનાનું નામ*",
  Enterschemename: "યોજનાનું નામ દાખલ કરો",
  EnteraproperVersion: "યોગ્ય સંસ્કરણ દાખલ કરો.",

  //Application Version Master
  ApplicationVersionMaster: "એપ્લિકેશન સંસ્કરણ માસ્ટર",
  DeviceOS: "ઉપકરણ O.S.",
  Version: "સંસ્કરણ",
  PopupMessage: "પોપઅપ સંદેશ",
  ForceUpdate: "ફોર્સ સુધારા",
  EnterVersion: "સંસ્કરણ દાખલ કરો",

  // Page Content Configuration
  PageContentConfiguration: "પેજ સામગ્રી રૂપરેખાંકન",
  DetailsID: "વિગતો આઈડી",
  EnterDetailsID: "વિગતો આઈડી દાખલ કરો",
  LanguageCode: "ભાષા કોડ",
  LanguageID: "ભાષા આઈડી",
  EnterLanguageID: "ભાષા આઈડી દાખલ કરો",
  DetailData: "વિગતો માહિતી",
  EnterDetailData: "વિગતો માહિતી દાખલ કરો",

  // Virtual Card Product Type Configuration
  VirtualCardProductTypeConfiguration:
    "વર્ચ્યુઅલ કાર્ડ ઉત્પાદન પ્રકાર રૂપરેખાંકન",
  ProductType: "ઉત્પાદનો પ્રકાર",
  CardProductBIN: "કાર્ડ ઉત્પાદન BIN",
  EnterCardProductBIN: "કાર્ડ ઉત્પાદન BIN દાખલ કરો",
  ProductID: "ઉત્પાદન ID",
  EnterProductID: "ઉત્પાદન ID દાખલ કરો",
  ProductName: "ઉત્પાદન નામ",
  EnterProductName: "ઉત્પાદન નામ દાખલ કરો",
  VerifiedBy: "દ્વારા ચકાસાયેલ",
  VerifiedDate: "ચકાસાયેલ તારીખ",
  VirtualCardProductTypeConfigurationConfirmation:
    "વર્ચ્યુઅલ કાર્ડ ઉત્પાદન પ્રકાર રૂપરેખાંકન પુષ્ટિ",
  CardLimit: "કાર્ડ મર્યાદા",
  EnterCardLimit: "કાર્ડ મર્યાદા દાખલ કરો",
  FinancialProfile: "નાણાકીય રૂપરેખા",
  EnterFinancialProfile: "નાણાકીય રૂપરેખા દાખલ કરો",
  LimitCurrency: "ચલણની મર્યાદા",
  LimitGroup: "મર્યાદા સમૂહ",
  EnterLimitGroup: "મર્યાદા સમૂહ દાખલ કરો",
  RMCode: "RM કોડ",
  EnterRMCode: "RM કોડ દાખલ કરો",
  AllowInIntroductionPage: "પરિચય પૃષ્ઠમાં મંજૂરી આપો",
  VirtualCardProductTypeDetails: "વર્ચ્યુઅલ કાર્ડ ઉત્પાદન પ્રકાર વિગતો",
  SchemeCodeReq: "યોજનાનો કોડ*",
  SchemecodeandConstitutionalreadyexistsatline:
    "યોજના કોડ અને બંધારણ પહેલાથી જ લાઇન {0} પર અસ્તિત્વમાં છે",
  ConstitutionReq: "બંધારણ*",
  EnterConstitution: "બંધારણ દાખલ કરો",

  //Customer Wise Limit Modification Confirmation
  CustomerWiseLimitModificationConfirmation:
    "ગ્રાહક મુજબની મર્યાદામાં ફેરફારની પુષ્ટિ",
  CustomerName: "ગ્રાહક નું નામ",
  UserWiseLimitConfirmation: "વપરાશકર્તા મુજબની મર્યાદા પુષ્ટિ",
  UserWiseLimitConfiguration: "વપરાશકર્તા મુજબની મર્યાદા રૂપરેખાંકન",
  Retry: "ફરી પ્રયાસ કરો",
  CustomerDetails: "ગ્રાહક વિગતો",
  CardMinimumAmt: "કાર્ડ લઘુત્તમ રકમ.",
  MaximumAmountReq: "મહત્તમ રકમ*",
  MinimumAmountReq: "લઘુત્તમ રકમ*",
  DailyLimitReq: "દૈનિક મર્યાદા*",
  Thistypealreadyexists: "આ પ્રકાર પહેલેથી જ અસ્તિત્વમાં છે.",

  // Customer Activation
  CustomerActivation: "ગ્રાહક સક્રિયકરણ",
  ActivationUsing: "સક્રિયકરણનો ઉપયોગ કરીને",
  SelectOption: "વિકલ્પ પસંદ કરો",
  ClientID: "ગ્રાહક ID",
  EnterClientID: "ગ્રાહક ID દાખલ કરો",
  CardNumber: "કાર્ડ નંબર",
  EnterCardNumber: "કાર્ડ નંબર દાખલ કરો",
  RegWith: "રજી. સાથે",
  RegAccount: "રજી. ખાતું",
  Name: "નામ",
  BirthDate: "જન્મતારીખ",
  EMailAddress: "ઈ - મેઈલ સરનામું",
  NoteAfterconfirmationtemporarypasswordwillbesenttotheregisteredmobilenumber:
    "નોંધ :- પુષ્ટિકરણ પછી અસ્થાયી પાસવર્ડ રજિસ્ટર્ડ મોબાઈલ નંબર પર મોકલવામાં આવશે.",
  FetchDetails: "વિગતો મેળવો",
  AccountCardNumber: "ખાતું/કાર્ડ નંબર",
  CustomerID: "ગ્રાહક ઓળખાણ પત્ર",
  EnterCustomerID: "ગ્રાહક ઓળખાણ પત્ર દાખલ કરો",
  Constitution: "બંધારણ",
  AccountTypeName: "ખાતાના પ્રકારનું નામ",
  Gender: "જાતિ",
  FatherName: "પિતાનું નામ",
  MotherName: "માતાનું નામ",
  LinkedAccount: "જોડાયેલ ખાતું",
  FullName: "પૂરું નામ",
  TINNumber: "TIN નંબર",
  NationalID13Digit: "રાષ્ટ્રીય ID 13 અંક",
  ModeOfOperation: "કામગીરીની રીત",
  Nationality: "રાષ્ટ્રીયતા",
  NationalID: "રાષ્ટ્રીય ID",
  IdentificationNumber: "ઓળખ નંબર",
  CustomerCardDetails: "ગ્રાહક કાર્ડ વિગતો",
  CardDetails: "કાર્ડ વિગતો",
  CustomerActivationConfirmation: "ગ્રાહક સક્રિયકરણ પુષ્ટિ",
  RequestDate: "વિનંતી તારીખ",
  RequestNumber: "વિનંતી નંબર",
  RequestBy: "દ્વારા વિનંતી",
  accountCardType: "એકાઉન્ટ કાર્ડ/પ્રકાર",

  // Customer Searching
  CustomerSearching: "ગ્રાહક શોધ",
  GetDetails: "વિગતો મેળવો",
  ClientIDCBNumber: "ગ્રાહક ID/CB નંબર",
  TIN: "TIN",
  NoteAllFieldscontainawildsearchfacility:
    "નોંધ :- બધા ફીલ્ડમાં વાઇલ્ડ સર્ચની સુવિધા છે.",
  Pleaseenteravalidemailaddress: "કૃપા કરીને માન્ય ઇમેઇલ સરનામું દાખલ કરો",
  PrimaryAccountCardNumber: "પ્રાથમિક એકાઉન્ટ/કાર્ડ નંબર",
  PrimaryCBNumber: "પ્રાથમિક CB નંબર",
  PrimarySource: "પ્રાથમિક સ્ત્રોત",
  AdminRemarks: "એડમિન ટિપ્પણીઓ",
  AuthFlag: "ઓથ. ધ્વજ",
  LimitModification: "ફેરફાર મર્યાદા",
  CurrentRelationshipData: "વર્તમાન સંબંધ ડેટા",
  Restrict: "પ્રતિબંધ",
  Unlock: "અનલોક કરો",
  Remarks: "ટિપ્પણીઓ",
  EnterRemarks: "ટિપ્પણીઓ દાખલ કરો",
  TransactionTypeReq: "વ્યવહારનો પ્રકાર*",
  Dailylimitshouldbelessthanweeklylimit:
    "દૈનિક મર્યાદા સાપ્તાહિક મર્યાદા કરતાં ઓછી હોવી જોઈએ.",
  DailylimitshouldbelessthanMonthlylimit:
    "દૈનિક મર્યાદા માસિક મર્યાદા કરતાં ઓછી હોવી જોઈએ.",
  WeeklyLimitshouldbemorethenDailyLimit:
    "સાપ્તાહિક મર્યાદા દૈનિક મર્યાદા કરતાં વધુ હોવી જોઈએ",
  PasswordReset: "પાસવર્ડ રીસેટ કરો",
  CBNumber: "CB નંબર",
  IdentificationNo: "ઓળખ નં.",
  DoyouwanttoPasswordReset: "શું તમે પાસવર્ડ રીસેટ કરવા માંગો છો?",
  RefreshCustomerRelationshipData: "ગ્રાહક સંબંધ ડેટા રિફ્રેશ કરો",
  FetchData: "ડેટા મેળવો",
  PrimaryAccountCard: "પ્રાથમિક ખાતું/કાર્ડ",
  LastLoginDate: "છેલ્લી લૉગિન તારીખ",
  PasswordChangeDate: "પાસવર્ડ બદલવાની તારીખ",

  RestrictionRemarks: "પ્રતિબંધ ટિપ્પણી",
  UnlockingRemarks: "અનલોક ટિપ્પણી",
  UpdateData: "અપડેટ ડેટા",

  // Password Reset Confirmation
  PasswordResetConfirmation: "પાસવર્ડ રીસેટ પુષ્ટિ",
  AcceptRemarks: "ટિપ્પણીઓ સ્વીકારો",
  RejectionRemarks: "ટિપ્પણી અસ્વીકાર",

  // Primary Identifier Change
  PrimaryIdentifierChange: "પ્રાથમિક ઓળખકર્તા ફેરફાર",
  Search: "શોધો",
  SignUpWith: "સાઇન અપ કરો",
  PrimaryIdentifierChangeConfirmation: "પ્રાથમિક ઓળખકર્તા ફેરફારની પુષ્ટિ",
  OldPrimarySource: "જૂનો પ્રાથમિક સ્ત્રોત",
  NewPrimarySource: "નવો પ્રાથમિક સ્ત્રોત",
  OldCBNumber: "જૂનો CB નંબર",
  NewCBNumber: "નવો CB નંબર",
  OldCardAccountNumber: "જૂનું કાર્ડ/ખાતા નંબર",
  NewCardAccountNumber: "નવું કાર્ડ/ખાતા નંબર",
  SetAsPrimary: "પ્રાથમિક તરીકે સેટ કરો",
  DoyouwanttosetthisaccountcardasaPrimaryIdentifier:
    "શું તમે આ ખાતા/કાર્ડને પ્રાથમિક ઓળખકર્તા તરીકે સેટ કરવા માંગો છો?",

  //CIB Loan Request Check
  CIBLoanRequestCheck: "CIB લોન વિનંતીની તપાસ",
  LoanRequestCheck: "લોન વિનંતી તપાસો",
  FileNumber: "ફાઇલ નંબર",
  ApplicantName: "અરજદારનું નામ",
  TDAccount: "TD ખાતું",
  LoanAmount: "લોનની રકમ",
  EMIAmount: "EMI રકમ",
  LockBy: "દ્વારા લોક",
  CIBCalculationView: "CIB ગણતરી | જુઓ",
  AppliedLoanamount: "લાગુ કરેલી લોનની રકમ",
  ProposedEMIamount: "પ્રસ્તાવિત EMI રકમ",
  AppliedTenor: "લાગુ કરેલ ટેનર",
  DOB: "જન્મતારીખ",
  DistrictofBirth: "જન્મ જિલ્લો",
  NID: "NID",
  ETINNumber: "E-TIN નંબર",
  SmartCardNumber: "સ્માર્ટ કાર્ડનો નંબર",
  SpouseName: "જીવનસાથીનું નામ",
  PermanentAddress: "કાયમી સરનામુ",
  PresentAddress: "હાલનું સરનામું",
  CIBUserInformation: "CIB વપરાશકર્તા માહિતી",
  CIBStatus: "CIB સ્થિતિ",
  Pleaseselectstatus: "કૃપા કરીને સ્થિતિ પસંદ કરો",
  DateRange: "તારીખ શ્રેણી",
  FileUploadRequired: "ફાઇલ અપલોડ જરૂરી છે.",
  DoYouwanttoacceptLoanRequest: "શું તમે લોનની વિનંતી સ્વીકારવા માંગો છો?",
  YouCantviewthisRequest: "તમે આ વિનંતી જોઈ શકતા નથી.",
  Decline: "નકાર",

  // Loan Closure Request
  LoanClosureRequest: "લોન બંધ કરવાની વિનંતી",
  LoanAccount: "લોન ખાતું",
  FromAccount: "ખાતામાંથી",
  ClosureDate: "બંધ થવાની તારીખ",
  Amount: "રકમ",
  CreditAccount: "ક્રેડિટ ખાતું",
  Outstanding: "બાકી",
  ClosingFee: "સમાપ્તિ ફી",
  VAT: "VAT",
  TOTALAMOUNT: "કુલ રકમ",

  //Tag Account Request
  TagAccountRequest: "ટેગ ખાતાંની વિનંતી",
  RequestType: "વિનંતીનો પ્રકાર",
  TagCreditCardRequest: "ટેગ ક્રેડિટ કાર્ડ વિનંતી",
  SearchingParameters: "પરિમાણો શોધી રહ્યા છીએ",
  AppliedFilters: "લાગુ ફિલ્ટર્સ",

  // Loan Release Lock Request
  LoanReleaseLockRequest: "લોન રીલીઝ લોક વિનંતી",
  FDAccount: "FD ખાતું",
  RequestReleasedSuccessfully: "વિનંતી સફળતાપૂર્વક રિલીઝ થઈ.",
  AreYouSuretoReleaseLockedRequest:
    "શું તમે લૉક કરેલી વિનંતીને રિલીઝ કરવા માટે ચોક્કસ છો?",

  // From Source Key Template
  FromSourceKeyTemplate: "સ્ત્રોત કી નમૂનામાંથી",
  SettoFromSource: "સ્ત્રોતમાંથી પર સેટ કરો",
  ResponseValue: "પ્રતિભાવ મૂલ્ય*",
  EnterResponseValue: "પ્રતિભાવ મૂલ્ય દાખલ કરો",
  TemplateSetAs: "નમૂના તરીકે સેટ કરો",
  CurrentConfig: "વર્તમાન રૂપરેખા.",
  SetFromSourceKeyTemplateOf: "ના સ્ત્રોત કી નમૂનામાંથી સેટ કરો",

  // Account Deletion Request For Checker
  AccountDeletionRequestForChecker: "ચેકર માટે ખાતું કાઢી નાખવાની વિનંતી",
  PrimaryAccount: "પ્રાથમિક ખાતું",
  PrimaryCBNo: "પ્રાથમિક સીબી નં.",
  DeletionReason: "કાઢી નાખવાનું કારણ",
  RejectRemarks: "રિમાર્કસ નકારી કાઢો",

  // Account Deletion Request For Approval
  AccountDeletionRequestForApproval: "મંજૂરી માટે ખાતું કાઢી નાખવાની વિનંતી",
  AcceptedBy: "દ્વારા સ્વીકૃત",
  CheckerAcceptDate: "પરીક્ષક તારીખ સ્વીકારો",
  CheckerRemarks: "પરીક્ષક ટિપ્પણીઓ",

  // Rooted Device Repository Allow/Disallow
  RootedDeviceRepositoryAllowDisallow:
    "રૂટ કરેલ ડિવાઇસ સંગ્રહાલય મંજૂરી આપો/અસ્વીકાર કરો",
  RootedDeviceRepository: "રૂટ કરેલ ડિવાઇસ સંગ્રહાલય",
  DeviceID: "ઉપકરણ ID",
  DevicesOS: "ઉપકરણ OS",
  DeviceName: "ઉપકરણનું નામ",
  DeviceUserName: "ઉપકરણ વપરાશકર્તા નામ",
  DeviceIP: "ઉપકરણ IP",
  AppVersion: "એપ્લિકેશન સંસ્કરણ",
  DeviceIMEI: "ઉપકરણ IMEI",
  Maker: "નિર્માતા",
  MakerRemark: "નિર્માતા ટિપ્પણી",
  Checker: "તપાસનાર",
  CheckerRemark: "પરીક્ષક ટિપ્પણી",
  Disallow: "નામંજૂર કરો",
  Allow: "મંજૂરી આપો",
  AllowRemarks: "ટિપ્પણીઓ મંજૂર કરો",
  DisallowRemarks: "ટિપ્પણીઓ નામંજૂર કરો",
  RootedDeviceAllowDisallowConfirmation:
    "રુટ કરેલ ઉપકરણ પુષ્ટિકરણને મંજૂરી આપે છે/નકારે છે",
  ConfirmationRemarks: "પુષ્ટિકરણ ટિપ્પણી",

  // Corporate User Registration Entry

  CorporateUserRegistrationEntry: "કોર્પોરેટ યુઝર રજીસ્ટ્રેશન એન્ટ્રી",
  DomainName: "ડોમેન નામ",
  RegDate: "રજિસ્ટર તારીખ",
  ACNo: "એ/સી. નં.",
  Sign: "સંતક",
  OwnAC: "સ્વંતઃ એ/સી",
  SanctionAmount: "મંજૂરી રકમ",
  WithinBank: "બેંક અંદર",
  EFT: "EFT",
  IMPS: "IMPS",
  UtilityBillPayment: "યુટિલિટી બિલ ચૂકવણી",
  PaymentGetway: "ચૂકવણી ગેટવે",
  FromAmounts: "પાછળથી રકમ",
  ToAmounts: "સુધી રકમ",
  ByNumberofUser: "યુઝર સંખ્યા દ્વારા",
  CustomerType: "ગ્રાહક પ્રકાર",
  PersonName: "વ્યક્તિનું નામ",
  Document: "દસ્તાવેજ",
  DocumentNo: "દસ્તાવેજ નંબર",
  UploadDocument: "દસ્તાવેજ અપલોડ કરો",
  ViewDocument: "દસ્તાવેજ જુઓ",
  AuthLetter: "પરવાના પત્ર",
  ViewAuthLetter: "પરવાના પત્ર જુઓ",
  Deactive: "નિષ્ક્રિય",
  DeactiveReason: "નિષ્ક્રિય કારણ",
  UserRights: "યુઝર હકો",
  PanNo: "પેન નંબર",
  UserLimit: "યુઝર મર્યાદા",
  ViewOnly: "માત્ર જુઓ",
  PerDayLimit: "પ્રતિદિન મર્યાદા",
  SpecialAuthorized: "વિશેષ મંજૂર",
  CorporateUserRegistration: "કોર્પોરેટ યુઝર રજીસ્ટ્રેશન",
  PerDayMaxLimit: "પ્રતિદિન મહત્તમ મર્યાદા",
  Limit: "મર્યાદા",
  ControllingPerson: "નિયંત્રણ કરનારો વ્યક્તિ",
  CorporateFinanceDepartment: "કોર્પોરેટ ફાઇનાન્સ વિભાગ",
  AccountMapping: "એકાઉન્ટ મેપિંગ",
  AuthenticationWorkflow: "પ્રમાણીકરણ વર્કફ્લો",
  EffectiveDailyLimit: "પ્રભાવશીલ દૈનિક મર્યાદા",
  LimitAmount: "મર્યાદા રકમ",

  // Admin Panel User Maintenance
  AdminPanelUserMaintenance: "એડમિન પેનલ યુઝર મેન્ટેનન્સ",
  UserGroupName: "યુઝર ગ્રુપ નામ",
  GroupName: "ગ્રુપ નામ",
  AllowRelease: "મંજૂરી રિલીઝ",
  UserSubtype: "વપરાશકર્તા પેટા પ્રકાર",
  NotificationTemplate: "સૂચનાનો નમૂનો",
  ConfirmedStatus: "પુષ્ટિત સ્થિતિ",
  AdminPanelUserConfirmation: "એડમિન પેનલ યુઝર પુષ્ટિ",
  UserLevel: "વપરાશકર્તા સ્તર",
  EnterUserID: "વપરાશકર્તા ID દાખલ કરો",
  EnterUserfullnamehere: "અહીં વપરાશકર્તાનું પૂરું નામ દાખલ કરો",
  ConfirmPasswordValidation: "નવો પાસવર્ડ અને પાસવર્ડની પુષ્ટિ મેળ ખાતા નથી",
  ChangePasswordValidation:
    "પાસવર્ડ આલ્ફાન્યૂમેરિક હોવો જોઈએ અને તેમાં ઓછામાં ઓછું એક ખાસ કેરેક્ટર,એક સ્મોલ કેરેક્ટર,એક કેપિટલ કેરેક્ટર તેની વચ્ચે કોઈ જગ્યા વગર હોવો જોઈએ.",
  NewPassword: "નવો પાસવર્ડ",
  ConfirmPassword: "પાસવર્ડની પુષ્ટિ કરો",
  InactiveDate: "નિષ્ક્રિય તારીખ",
  UpdateDetails: "અપડેટ વિગતો",
  AdminUserConfirmation: "એડમિન યુઝર પુષ્ટિ",
  ConfirmationColumnDetails: "પુષ્ટિ કૉલમ વિગતો",
  OldValue: "જૂની કિંમત",
  LabelName: "લેબલ નામ",
  NewValue: "નવી કિંમત",
  MakerDate: "નિર્માતા તારીખ",
  MobileNoisrequired: "મોબાઈલ નંબર જરૂરી છે",

  // Admin Panel User Release
  AdminPanelUserRelease: "એડમિન પેનલ વપરાશકર્તા પ્રકાશન",
  LoginTime: "લૉગિન સમય",
  Operation: "કામગીરી",
  LoginDateTime: "લોગિન તારીખ-સમય",
  BlockedReason: "અવરોધિત કારણ",
  LogoutDateTime: "લોગઆઉટ તારીખ-સમય",
  ViewAll: "બધુ જુઓ",
  ReleaseBlockedUser: "અવરોધિત વપરાશકર્તાને રિલીઝ કરો",
  ReleaseUsers: "રીલીઝ યુઝર(ઓ)",
  Userissuccessfullyreleased: "વપરાશકર્તા સફળતાપૂર્વક પ્રકાશિત થયો છે",
  Loggedin: "લૉગ ઇન કર્યું",
  WouldyouliketoreleasetheselectedBlockedUsers:
    "શું તમે પસંદ કરેલા અવરોધિત વપરાશકર્તા(ઓ) ને છોડવા માંગો છો?",
  WouldyouliketoreleasetheselectedLoggedinUsers:
    "શું તમે પસંદ કરેલા લૉગ ઈન યુઝરને રિલીઝ કરવા માંગો છો?",
  AdminPanelBlockedUserRelease: "એડમિન પેનલ અવરોધિત વપરાશકર્તા પ્રકાશન",
  BlockedUserName: "અવરોધિત વપરાશકર્તા નામ",
  FailureAttemptCount: "નિષ્ફળ પ્રયાસની ગણતરી",
  ListofFailedLoginAttempts: "નિષ્ફળ લૉગિન પ્રયાસોની સૂચિ",
  UserFailedAttemptDetails: "વપરાશકર્તા નિષ્ફળ પ્રયાસ વિગતો",
  ReleaseReason: "પ્રકાશન કારણ",
  ApplicationSessionID: "અરજી સત્ર ID",

  // Screen Access Rights
  ScreenAccessRights: "સ્ક્રીન ઍક્સેસ અધિકારો",
  GroupNames: "ગ્રુપ નામો",
  AccessDetail: "ઍક્સેસ વિગતો",
  Groups: "જૂથો",
  Users: "વપરાશકર્તાઓ",
  Youcannotmodifyyourownrights:
    "તમે તમારા પોતાના અધિકારોને સંશોધિત કરી શકતા નથી.",
  AreyouwanttopopulateitsGroupRight:
    "શું તમે તેના ગ્રૂપ રાઈટને પોપ્યુલેટ કરવા માંગો છો?",
  MenuList: "મેનુ યાદી",
  PendingScreenAccess: "સ્ક્રીન ઍક્સેસ બાકી છે",
  CurrentScreenAccess: "વર્તમાન સ્ક્રીન ઍક્સેસ",
  AssignUserGroupRights: "વપરાશકર્તા/જૂથ અધિકારો સોંપો",
  CarryForwardScreenRightsFrom: "માંથી ફોરવર્ડ સ્ક્રીન અધિકારો લઈ જાઓ",
  YoucannotCarryForwardRightsforsameuser:
    "તમે સમાન વપરાશકર્તા માટે ફોરવર્ડ અધિકારો લઈ શકતા નથી.",
  AssignUserGroupRightsTo: "ને વપરાશકર્તા/જૂથ અધિકારો સોંપો ",
  FastForward: "ઝડપી આગળ",
  FastRewind: "ઝડપી રીવાઇન્ડ",
  ScreenAccessRightsOf: "ના સ્ક્રીન ઍક્સેસ અધિકારો {0} વપરાશકર્તા",
  User: " વપરાશકર્તા",

  // Admin Panel User Group
  AdminPanelUserGroupCreation: "એડમિન પેનલ વપરાશકર્તા જૂથ બનાવટ",
  NoofScreenstodisplayunderRecentOption:
    "તાજેતરના વિકલ્પ હેઠળ પ્રદર્શિત કરવા માટે સ્ક્રીનોની સંખ્યા",
  LoginPasswordForceExpiryDays: "લોગિન પાસવર્ડ ફોર્સ સમાપ્તિ દિવસો",
  EnterLoginPasswordForceExpiryDays:
    "લોગિન પાસવર્ડ ફોર્સ એક્સપાયરી દિવસો દાખલ કરો",
  AdminUserGroupMaintenance: "એડમિન વપરાશકર્તા જૂથ જાળવણી",
  EnterUserGroupName: "વપરાશકર્તા ગ્રુપનું નામ દાખલ કરો",
  NoofScreensunderRecentOption: "તાજેતરના વિકલ્પ હેઠળ સ્ક્રીનની સંખ્યા",
  EnterNoofScreensunderRecentOption:
    "તાજેતરના વિકલ્પ હેઠળ સ્ક્રીનની સંખ્યા દાખલ કરો",
  UserGroup: "વપરાશકર્તા જૂથ",

  // Admin User Notification Template
  AdminUserNotificationTemplate: "એડમિન વપરાશકર્તા સૂચના નમૂનો",
  NotificationTemplateName: "સૂચના નમૂનાનું નામ",
  AdminUserNotificationTemplateName: "એડમિન વપરાશકર્તા સૂચના નમૂનાનું નામ",
  EnterAdminUserNotificationTemplateName:
    "એડમિન વપરાશકર્તા સૂચના નમૂનાનું નામ દાખલ કરો",
  UserLoginIDReq: "વપરાશકર્તા લોગિન ID*",
  USERLoginIDisAlreadyenteredatLine: "USER લૉગિન ID પહેલેથી જ",

  // Release Block Users
  ReleaseBlockUsers: "વપરાશકર્તાઓને રિલીઝ કરો",
  ReleaseTypeReq: "પ્રકાશનનો પ્રકાર*",
  BlockTypeReq: "બ્લોકનો પ્રકાર*",
  BlockDate: "તારીખ બ્લોક કરો",
  BlockReason: "કારણ અવરોધિત કરો",
  ReleaseCardPINBlockUsers: "કાર્ડ PIN બ્લોક વપરાશકર્તાઓને રિલીઝ કરો",
  ActivityType: "પ્રવૃત્તિનો પ્રકાર",
  Details: "વિગતો",
  Areyousureyouwanttorelease: "શું તમે ખરેખર રિલીઝ કરવા માંગો છો",
  ReleasePGWBlockUsers: "PGW બ્લોક વપરાશકર્તાઓને મુક્ત કરો",
  Fetch: "મેળવો",

  // DBR Loan Request Check
  DBRLoanRequestCheck: "DBR લોન વિનંતી ચકાસણી",
  CustomerLoanRequestInformation: "ગ્રાહક લોન વિનંતી માહિતી",
  Profession: "વ્યાવસાય",
  NetMonthlyIncomeA: "નેટ માસિક આવક (એ)",
  TDAccountNumber: "TD એકાઉન્ટ નંબર",
  TenorMonth: "સમયાવધિ (મહિના)",
  TDAmountC: "TD રકમ (સી)",
  RateofInterest: "વ્યાજની દર",
  EMIB: "EMI (બી)",
  AccountforEncashEMI: "એન્કાશ ઈએમઆઈ માટે એકાઉન્ટ",
  DBRBA: "DBR(B/A)%",
  LoanRequestRecommendedInformation: "લોન વિનંતી ભલામણ માહિતી",
  LoanAmountD: "લોન રકમ (ડી)",
  OtherLoanInstF: "અન્ય લોન ઇન્સ્ટીટ્યુટ (એફ)",
  CreditCardlimitG: "ક્રેડિટ કાર્ડ લિમિટ (જી)",
  DBRF5ofGA100: "DBR% ((F + 5% ઓફ G)/A)*100",
  EMIE: "EMI (ઈ)",
  LTVDC: "LTV% (ડી/સી)",
  FinalLoanAmountLTVC: "અંતિમ લોન રકમ (LTV * C)",
  CIBRemarks: "CIB ટિપ્પણીઓ",
  MessagefromDBR: "DBR થી સંદેશ",
  DBRRemarks: "DBR ટિપ્પણીઓ",
  Requesthasalreadybeenprocessed: "વિનંતી પહેલેથી પ્રક્રિયામાં આવી છે.",
  ViewDocuments: "દસ્તાવેજો જુઓ",

  // Loan Approval Detail
  LoanApprovalDetail: "લોન મંજૂરી વિગત",
  LoanApprovalRequestDetails: "લોન મંજૂરી વિનંતી વિગતો",
  FileReferenceNo: "ફાઈલ સંદર્ભ નંબર",
  SecurityValueTDAmount: "સુરક્ષા મૂલ્ય / TD રકમ",
  AssessedbyDBRID: "મૂલ્યાંકન કરાયેલ દ્વારા / DBR ID",
  AssessedbyDBRName: "મૂલ્યાંકન કરાયેલ દ્વારા / DBR નામ",
  AssessedDate: "મૂલ્યાંકન તારીખ",
  LTV: "LTV%",
  NetMonthlyIncome: "નેટ માસિક આવક",
  Tenor: "સમયાવધિ",
  OtherLoanInstallment: "અન્ય લોન ઇન્સ્ટોલમેન્ટ",
  CreditCardlimit: "ક્રેડિટ કાર્ડ લિમિટ",
  EMI: "EMI",
  DBR: "DBR",
  SOLID: "SOL ID",
  FinalLoanAmount: "અંતિમ લોન રકમ",
  MessageFromApproval: "મંજૂરીથી સંદેશ",

  // Enter Retrieval Parameters
  EnterRetrievalParameters: "પુનઃપ્રાપ્તિના પરિમાણો દાખલ કરો",
  ToDateshouldbegreaterthanorequaltoFromDate:
    "આજની તારીખ તારીખથી કરતાં મોટી અથવા તેની બરાબર હોવી જોઈએ.",
  FromDateshouldbelessthanorequaltoToDate:
    "થી તારીખ આજની તારીખ કરતાં ઓછી અથવા બરાબર હોવી જોઈએ.",
  today: "આજ",
  accept: "સ્વીકારો",
  cancel: "રદ કરો",

  //REPORT
  RetrievalParameters: "પુનઃપ્રાપ્તિના પરિમાણો",
  Searched: "",
  records: "રેકોર્ડ શોધો",
  showFilters: "ફિલ્ટર્સ બતાવો",
  ClearFilter: "ફિલ્ટરને સાફ કરો",
  ExpandRows: "પંક્તિઓ વિસ્તૃત કરો",
  Export: "નિકાસ કરો",
  Showexportoptions: "નિકાસ વિકલ્પો બતાવો",
  RetrieveData: "ડેટા પુનઃપ્રાપ્ત કરો",
  RequiredValueMissingForLoginID: "લોગિન ID માટે જરૂરી મૂલ્ય ખૂટે છે.",
  rowswillbeexported: "પંક્તિ(ઓ) નિકાસ કરવામાં આવશે.",
  Nodatafoundtoexport: "નિકાસ કરવા માટે કોઈ ડેટા મળ્યો નથી",
  ReportExportStatus: "નિકાસ સ્થિતિની જાણ કરો",
  // Customer Registration Report
  CustomerRegistrationReport: "ગ્રાહક નોંધણી અહેવાલ",
  RegAccountCardNumber: "રજિસ્ટર્ડ ખાતું/કાર્ડ નંબર",
  Source: "સ્રોત",
  AuthWith: "અનુમતિ સાથે",
  LastPassChange: "છેલ્લો પાસવર્ડ બદલાવ",

  // User Login History
  UserLoginHistory: "વપરાશકર્તા લોગીન ઇતિહાસ",
  LoginDate: "લોગીન તારીખ",
  LoginBy: "લોગીન દ્વારા",

  // Password Change History
  PasswordChangeHistory: "પાસવર્ડ બદલવાનો ઇતિહાસ",
  PasswordModifyDate: "પાસવર્ડ ફેરફાર તારીખ",

  // User Activity
  UserActivity: "વપરાશકર્તા પ્રવૃત્તિ",
  ActivityCode: "પ્રવૃત્તિ કોડ",
  ActivityTime: "પ્રવૃત્તિ સમય",
  ActivityDescription: "પ્રવૃત્તિ વર્ણન",

  // Fund Transfer Transaction Details
  FundTransferTransactionDetails: "ફંડ ટ્રાન્સફર ટ્રાન્ઝક્શન વિગતો",
  TransactionStatus: "ટ્રાન્ઝક્શન સ્થિતિ",
  TransactionDate: "ટ્રાન્ઝક્શન તારીખ",
  VATAmount: "VAT રકમ",
  FromSource: "સ્ત્રોત માંથી",
  FromACNo: "ખાતા નંબર માંથી",
  FromACName: "ખાતા નામ પરથી",
  ToACNo: "ખાતા નંબર માટે",
  ToACName: "ખાતા નામ માટે",
  ToIFSCCode: "IFSC કોડ માટે",
  ProcessDate: "પ્રક્રિયા તારીખ",
  RefNo: "રેફ નંબર",
  OTPType: "OTP પ્રકાર",
  FromContactNo: "સંપર્ક નંબર પરથી",
  FromEmailID: "ઈમેલ આઈડી પરથી",
  ToContactNo: "સંપર્ક કરવા માટે નં",
  ToEmailID: "ઈમેલ આઈડી પર",
  TransFlow: "ટ્રાન્ઝક્શન ફ્લો",
  NickName: "ઉપનામ",

  APIResponseDetailsReport: "API પ્રતિસાદ વિગતો અહેવાલ",
  ApiName: "Api નામ",
  RespCode: "જવાબ કોડ",
  RefTranID: "સંદર્ભ વ્યવહાર ID",
  ResponseMessage: "પ્રતિભાવ સંદેશ",
  ResponseDate: "પ્રતિભાવ તારીખ",
  ExportReportform: "નિકાસ અહેવાલ ફોર્મ",

  Selectfiletype: "ફાઈલનો પ્રકાર પસંદ કરો",
  Selectpagesize: "પાના નું માપ પસંદ કરો",
  Selectorientation: "અભિગમ પસંદ કરો",
  ShowHeader: "હેડર બતાવો",
  ColumnstoExport: "નિકાસ કરવા માટે કૉલમ",
  TransactionParticularsDetail: "વ્યવહારની પ્રત્યક્ષ વિગતો",
  Print: "છાપો",
  ResponseDetail: "પ્રતિભાવ વિગત",

  TransactionRefNumber: "વ્યવહાર સંદર્ભ નંબર",
  FromAccountNumber: "ખાતા નંબર પરથી",
  AbabilTrnParticulars: "એબાબિલ વ્યવહાર વિશેષ વિગતો",
  AbabilTrnParticulars2: "એબાબિલ વ્યવહાર વિશેષ વિગતો2",
  TranzwareTrnParticulars: "ટ્રાન્ઝવેર વ્યવહાર વિશેષ વિગતો",
  TranzwareTrnParticulars2: "ટ્રાન્ઝવેર વ્યવહાર વિશેષ વિગતો2",

  // Service Active/Deactive Register
  ServiceActiveDeactiveRegister: "સેવા સક્રિય/નિષ્ક્રિય રજિસ્ટર",
  SubTranType: "સબ વ્યવહાર પ્રકાર",
  FromDates: "તારીખ થી",
  ToDates: "તારીખ સુધી",
  DisplayMessage: "સંદેશ દર્શાવો",
  DisplayMessageDetail: "સંદેશની વિગતો દર્શાવો",

  // Mobile/Email Updation From Core Report
  MobileEmailUpdationFromCoreReport: "કોર રિપોર્ટમાંથી મોબાઇલ/ઇમેઇલ અપડેટ",
  UpdatedField: "અપડેટ કરેલ ક્ષેત્ર",

  // OTP Notification Report
  OTPNotificationReport: "OTP સૂચના અહેવાલ",
  TRNCode: "TRN કોડ",
  MobileNoEmailID: "મોબાઈલ નંબર/ઈમેલ આઈડી",
  SentTime: "મોકલવાનો સમય",
  MessageDescription: "સંદેશ વર્ણન",
  ApiResp: "Api પ્રતિભાવ",
  PageNumber: "પેજ ક્રમાંક",
  EnterPageNumber: "પેજ ક્રમાંક દાખલ કરો",
  PageSize: "પેજ નું કદ",
  EnterPageSize: "પેજ નું કદ દાખલ કરો",

  // List Of Club Member Report
  ListOfClubMemberReport: "ક્લબ સભ્ય અહેવાલ યાદી",
  Pleaseselectatleastonerow: "કૃપા કરીને ઓછામાં ઓછી એક પંક્તિ પસંદ કરો.",

  // Mobile/Email Notification Report
  MobileEmailNotificationReport: "મોબાઇલ/ઇમેઇલ સૂચના અહેવાલ",
  MessageType: "સંદેશનો પ્રકાર",

  // Beneficiary Detail Report
  BeneficiaryDetailReport: "લાભાર્થી વિગતવાર અહેવાલ",
  BeneficiaryType: "લાભાર્થીનો પ્રકાર",

  // Mobile/Email Updation From Citytouch Report
  MobileEmailUpdationFromCitytouchReport:
    "સિટીટચ રિપોર્ટ તરફથી મોબાઇલ/ઇમેઇલ અપડેટ",
  ReqestDate: "વિનંતીની તારીખ",
  ResponseCode: "પ્રતિભાવ કોડ",

  // Email Transfer Transaction Details
  EmailTransferTransactionDetails: "ઈમેઈલ ટ્રાન્સફર વ્યવહાર વિગતો",
  AcceptStatus: "સ્થિતિ સ્વીકારો",
  ResentCount: "રીસેન્ટ ગણતરી",
  CancelReason: "કારણ રદ કરો",

  // Cash By Code Transaction Details
  CashByCodeTransactionDetails: "કોડ દ્વારા રોકડ વ્યવહાર વિગતો",
  FromCardNumber: "કાર્ડ નંબર પરથી",
  LinkedACNo: "લિંક કરેલ ખાતા નંબર.",
  CodeViewBy: "કોડ દ્વારા જુઓ",
  CashByCode: "કોડ દ્વારા રોકડ",
  BenConatctNo: "લાભાર્થીનો સંપર્ક નં.",

  // Favourite Transaction Details
  FavouriteTransactionDetails: "મનપસંદ વ્યવહાર વિગતો",
  FavType: "મનપસંદ પ્રકાર",
  FavTranname: "મનપસંદ વ્યવહાર નામ",

  // Payment Details
  PaymentDetails: "ચુકવણીની વિગતો",
  PaymentDate: "ચુકવણીની તારીખ",
  ToSource: "સ્ત્રોત માટે",
  ServiceCharge: "સેવા ચાર્જ",
  Mobile: "મોબાઈલ",
  ResponseDesc: "પ્રતિભાવ વર્ણન.",
  RefTransactionID: "સંદર્ભ. વ્યવહાર ID",
  MerchantName: "વેપારીનું નામ",
  Frequency: "આવર્તન",
  AsonDate: "તારીખ મુજબ",
  DeselectAll: "બધાને નાપસંદ કરો",
  SelectAll: "બધા પસંદ કરો",

  // Schedule Payment Details
  SchedulePaymentDetails: "અનુસૂચિ ચુકવણીની વિગતો",
  LastProcessDate: "છેલ્લી પ્રક્રિયા તારીખ",
  DeactiveChannel: "નિષ્ક્રિય ચેનલ",
  PaymentType: "ચુકવણીનો પ્રકાર",
  NoofPayments: "ચુકવણીની સંખ્યા",
  PolicyNumber: "નીતિ નંબર",
  PolicyHolderName: "નીતિ ધારક નામ",
  PolicyPaidType: "નીતિ ચૂંટાયેલ પ્રકાર",
  ScheduleResponse: "અનુસૂચિ પ્રતિસાદ",

  ScheduleDetailsReport: "અનુસૂચિ વિગતો અહેવાલ",
  ScheduleDate: "અનુસૂચિ તારીખ",
  FromAccountNo: "ખાતા નં. માંથી.",
  FromAccountName: "ખાતાના નામ માંથી",
  ToAccountNo: "ખાતા નં. માટે",
  ToAccountName: "ખાતાના નામ માટે",
  BenContactNo: "લાભાર્થીનો સંપર્ક નં.",
  BenEmailID: "લાભાર્થીનો ઈમેલ આઈડી.",
  RefDate: "સંદર્ભ તારીખ",

  // Card Activate/Reset Pin Report
  CardActivateResetPinReport: "કાર્ડ સક્રિય/રીસેટ પિન રિપોર્ટ",
  TypeOfTran: "વ્યવહાર નો પ્રકાર.",
  CardNo: "કાર્ડ નંબર.",
  OldStatusOfCard: "કાર્ડની જૂની સ્થિતિ",
  NewStatusOfCard: "કાર્ડની નવી સ્થિતિ",
  ChangeReason: "કારણ બદલો",
  ResponseMesssage: "પ્રતિભાવ સંદેશ",

  // Tag Credit Card And Account Number Details
  TagCreditCardAndAccountNumberDetails:
    "ટેગ ક્રેડિટ કાર્ડ અને એકાઉન્ટ નંબર વિગતો",
  AcOrCardNo: "ખાતા અથવા કાર્ડ નં.",
  AcceptBy: "દ્વારા સ્વીકારો",
  AcceptDate: "તારીખ સ્વીકારો",
  AcceptanceRemarks: "સ્વીકૃતિ ટિપ્પણીઓ",

  // Untag Credit Card And Account Number Details
  UntagCreditCardAndAccountNumberDetails:
    "ક્રેડિટ કાર્ડ અને ખાતા નંબરની વિગતોને અનટેગ કરો",

  // Positive Pay Request Report
  PositivePayRequestReport: "હકારાત્મક પગાર વિનંતી અહેવાલ",
  BeneficiaryName: "લાભાર્થીનું નામ",
  ChequeDate: "તારીખ તપાસો",
  ChequeNumber: "નંબર ચેક કરો",
  ChequeBookNumber: "બુક નંબર તપાસો",

  // QR Generated Report
  QRGeneratedReport: "QR જનરેટેડ અહેવાલ",
  QRID: "ક્યૂઆર આઈડી",
  Currency: "ચલણ",
  ProcessStatus: "પ્રક્રિયા સ્થિતિ",

  // QR Merchant Payment Report
  QRMerchantPaymentReport: "QR વેપારી ચુકવણી અહેવાલ",

  // Cheque Book Request Report
  ChequeBookRequestReport: "ચેક બુક વિનંતી અહેવાલ",
  NoOfLeaf: "પર્ણની સંખ્યા",
  DeliveryBranch: "વિતરણ શાખા",

  // Cheque Stop Request Report
  ChequeStopRequestReport: "સ્ટોપ વિનંતી અહેવાલ તપાસો",
  BeginChequeNo: "ચેક નંબર શરૂ કરો.",
  ChequeNo: "ચેક નં.",
  ContactNo: "સંપર્ક નં.",

  // User Block Unblock Report
  UserBlockUnblockReport: "વપરાશકર્તા અવરોધિત અનાવરોધિત અહેવાલ",
  BlockType: "બ્લોક પ્રકાર",

  // Apply for Fixed Deposite Request Report
  ApplyforFixedDepositeRequestReport:
    "ફિક્સ્ડ ડિપોઝિટ વિનંતી અહેવાલ માટે અરજી કરો",
  TypeOfAccount: "ખાતાના પ્રકાર",
  AccountTitle: "ખાતાનું શીર્ષક",
  AvilBalance: "એવિલ સંતુલન",
  TenureType: "મુદતનો પ્રકાર",
  AutoRenewal: "સ્વતઃ નવીકરણ",
  IntRepayAccount: "વ્યાજ દર ચૂકવવાનું ખાતું ",
  CollectionBranch: "સંગ્રહ શાખા",
  InterestRate: "વ્યાજ દર",
  MaturityDate: "પરિપક્વતા તારીખ",
  ApplyForDepositPensionSchemeReport:
    "ડિપોઝિટ પેન્શન યોજના રિપોર્ટ માટે અરજી કરો",
  InstallStartDate: "પ્રારંભ તારીખ ઇન્સ્ટોલ કરો",
  GeneratedAccount: "જનરેટ કરેલ ખાતું",

  // Credit Card Payment Report
  CreditCardPaymentReport: "ક્રેડિટ કાર્ડ ચુકવણી અહેવાલ",
  ReferenceNo: "સંદર્ભ ક્રમાંક",
  FromACNumber: "ખાતા નંબર પરથી",
  ToCardNo: "કાર્ડ નંબર માટે.",
  Recipientname: "મેળવનારનું નામ",
  RecipientEmail: "મેળવનારનું ઇમેઇલ",
  CurrCode: "વર્તમાન કોડ",
  ToCurrCode: "વર્તમાન કોડ માટે",
  CurrInt: "વર્તમાન વ્યાજ",
  CardType: "કાર્ડનો પ્રકાર",
  TotalAmount: "કુલ રકમ",

  // Admin Panel User Application Usage History
  AdminPanelUserApplicationUsageHistory:
    "એડમિન પેનલ વપરાશકર્તા એપ્લિકેશન ઉપયોગ ઇતિહાસ",
  OpenDateAndTime: "તારીખ અને સમય ખોલો",
  CloseDateAndTime: "તારીખ અને સમય બંધ કરો",

  // Apply for Quick Loan Summary Report
  ApplyforQuickLoanSummaryReport: "ઝડપી લોન સારાંશ અહેવાલ માટે અરજી કરો",
  RequestDateandTime: "તારીખ અને સમય માટે વિનંતી કરો",
  EMIAccount: "EMI ખાતું",
  IntRate: "ઈન્ટ.રેટ",

  ApplyforQuickLoanDetailReport: "ઝડપી લોન વિગત અહેવાલ માટે અરજી કરો",
  LoanTenure: "લોનની મુદત",
  MonthlyIncome: "માસિક આવક",
  ProcessingFee: "પ્રોસેસિંગ ફી",
  FileREFNo: "ફાઈલ REF નંબર",
  ETINNo: "ઈટીઆઈએન નંબર",
  NIDNo: "એનઆઈડી નંબર",
  SmartCardNo: "સ્માર્ટ કાર્ડ નંબર",
  BirthPlace: "જન્મસ્થળ",
  SoalID: "સોલ આઈડી",
  SanIntRate: "સૅન્ટીન્ટ દર",
  OtherLoanEMI: "અન્ય લોન EMI",
  SanLoanAmount: "સેન લોન રકમ",
  EMIDate: "EMI તારીખ",
  CCLimitAmount: "સીસી લિમિટ રકમ",
  SanInstAmount: "સેન ઇન્સ્ટ રકમ",
  DBRAmount: "DBR રકમ",
  CIBUser: "CIB વપરાશકર્તા",
  CIBEnteredDate: "CIB દાખલ તારીખ",
  CIBMachineName: "CIB મશીન નામ",
  DBRUsers: "DBR વપરાશકર્તા",
  DBREnteredDate: "DBR દાખલ તારીખ",
  DBRMachineName: "DBR મશીન નામ",
  AuthUser: "પ્રમાણિક વપરાશકર્તા",
  AuthRemarks: "પ્રમાણિક ટકો",
  AuthEnteredDate: "પ્રમાણિક દાખલ તારીખ",
  AuthMachineName: "પ્રમાણિક મશીન નામ",
  RejectedBy: "નામંજૂર કરતા",
  RejectedDate: "નામંજૂર તારીખ",
  RejectedMachineName: "નામંજૂર મશીન નામ",
  FDBalance: "FD બેલેન્સ",

  // Merchant Transaction Report
  MerchantTransactionReport: "વેપારી વ્યવહાર અહેવાલ",
  RequestDateTime: "વિનંતી તારીખ સમય",
  UniqueID: "યુનિક આઈડી",
  BankRefID: "બેંક સંદર્ભ ID",
  MerchantReferenceID: "વેપારી સંદર્ભ ID",
  TokenNo: "ટોકન નંબર",
  ServiceType: "સેવાનો પ્રકાર",
  ReverseStatus: "વિપરીત સ્થિતિ",

  // Supporting Documents Upload Report
  SupportingDocumentsUploadReport: "સહાયક દસ્તાવેજો અપલોડ અહેવાલ",
  RegistrationDate: "નોંધણી તારીખ",
  ChangeRequestType: "વિનંતીનો પ્રકાર બદલો",
  APIResponceID: "API પ્રતિસાદ ID",
  DocumentName: "દસ્તાવેજનું નામ",
  DocumentFileName: "દસ્તાવેજ ફાઇલનું નામ",

  // Pay Order Details Report
  PayOrderDetailsReport: "પે ઓર્ડરની વિગતોનો અહેવાલ",
  TransactionTime: "વ્યવહાર સમય",
  TypeOfFundTransfer: "ફંડ ટ્રાન્સફરનો પ્રકાર",
  DeliveryBranchName: "વિતરણ શાખાનું નામ",
  TransferRefNumber: "સંદર્ભ નંબર ટ્રાન્સફર કરો",

  // FDR Issuance Report
  FDRIssuanceReport: "FDR જારી અહેવાલ",
  RequestCompletedDateTime: "વિનંતી પૂર્ણ તારીખ સમય",
  SOLDescription: "SOL વર્ણન",
  CIFID: "CIF ID",
  FDRType: "FDR પ્રકાર",
  AcName: "ખાતાનું નામ",
  AcOpeningDate: "ખાતું ખોલવાની તારીખ",
  IntCreditAcID: "વ્યાજ ક્રેડિટ ખાતાનું ID",
  IntCreditAcName: "વ્યાજ ક્રેડિટ ખાતાનું નામ",
  ValueDate: "મુલ્ય તારીખ",
  DepositAmount: "જમા રકમ",
  DepositPeriod: "જમા કરવાનો સમયગાળો",
  TenorType: "ટેનરનો પ્રકાર",
  MaturityValue: "પરિપક્વતા મૂલ્ય",
  RepaymentAcID: "ચુકવણી ખાતા ID",
  RepaymentAcName: "ચુકવણી ખાતાનું નામ",
  MaturityInstructions: "પરિપક્વતા સૂચનાઓ",
  AutoClosure: "ઓટો બંધ",
  SectorCode: "ક્ષેત્ર કોડ",
  SubSectorCode: "પેટા ક્ષેત્ર કોડ",
  OccupationCode: "વ્યવસાય કોડ",
  FreeCode3: "મફત કોડ 3",
  FreeCode6: "મફત કોડ 6",
  FreeCode7: "મફત કોડ 7",
  DebitAcID: "ડેબિટ ખાતું ID",
  DebitAcName: "ડેબિટ ખાતાનું નામ",
  NomineesName: "નામાંકિત વ્યક્તિનું નામ",
  Relationship: "સંબંધ",
  AddressLine1: "સરનામું લાઇન1",
  AddressLine2: "સરનામાની લાઇન નં 2",
  NomineePhotoID: "નામાંકિત ફોટો ID",
  City: "શહેર",
  State: "રાજ્ય",
  Country: "દેશ",
  NomineeMinor: "નામાંકિત સગીર",
  DateOfBirth: "જન્મ તારીખ",
  NomineePent: "નામાંકિત પેન્ટ.",
  RequestID: "વિનંતી ID",

  // DPS Issuance Report
  DPSIssuanceReport: "DPS જારી અહેવાલ",
  SISrlNo: "SI અનુ.નં.",
  StandInstFreqType: "સ્ટેન્ડ. ઇન્સ્ટ. આવર્તન. પ્રકાર",
  DayofStandInstFreq: "સ્ટેન્ડનો દિવસ. ઇન્સ્ટ. આવર્તન.",
  StandInstFreq: "સ્ટેન્ડ. ઇન્સ્ટ. આવર્તન.",
  NextExecutionDate: "આગામી અમલ તારીખ",

  // API Response Report
  APIResponseReport: "API પ્રતિભાવ અહેવાલ",
  APICallCount: "API કૉલ ગણતરી",

  // Admin Panel User Information Report
  AdminPanelUserInformationReport: "એડમિન પેનલ વપરાશકર્તા માહિતી અહેવાલ",
  CreationDate: "બનાવટની તારીખ",

  // Admin Panel User Activity Report
  AdminPanelUserActivityReport: "એડમિન પેનલ વપરાશકર્તા પ્રવૃત્તિ અહેવાલ",
  LogDescription: "લૉગનું વર્ણન",
  LoginIpAddress: "લોગિન આઈપી સરનામું",
  Terminal: "ટર્મીનલ",
  ReleasedBy: "દ્વારા પ્રકાશિત",
  ReleasedDate: "પ્રકાશન તારીખ",
  ReleasedIpAddress: "Ip સરનામું પ્રકાશિત",

  // Perameters Audit Trail
  PerametersAuditTrail: "પરિમાણ ઓડિટ ટ્રેઇલ",
  PeraNo: "પેરા નંબર.",
  ModifiedDateTime: "સુધારેલી તારીખ - સમય",

  // Admin Panel User Audit Trail Detail
  AdminPanelUserAuditTrailDetail: "એડમિન પેનલ વપરાશકર્તા ઓડિટ ટ્રેઇલ વિગતો",
  ActionDateTime: "ક્રિયા તારીખ અને સમય",
  AdminPanelUserWiseScreenAccessReport:
    "એડમિન પેનલ વપરાશકર્તા મુજબની સ્ક્રીન ઍક્સેસ અહેવાલ",
  ScreenCode: "સ્ક્રીન કોડ",

  // Monthly Service And Channel Wise MAU Report
  MonthlyServiceAndChannelWiseMAUReport: "માસિક સેવા અને ચેનલ મુજબ MAU અહેવાલ",
  Month: "મહિનો",
  Transaction: "વ્યવહાર",
  Volume: "વોલ્યુમ",
  UniqueCustomer: "અનન્ય ગ્રાહક",
  DailyServiceAndChannelWiseMAUReport: "દૈનિક સેવા અને ચેનલ મુજબ MAU અહેવાલ",

  // Monthly User And Channel Wise MAU Report
  MonthlyUserAndChannelWiseMAUReport:
    "માસિક વપરાશકર્તા અને ચેનલ મુજબનો MAU અહેવાલ",
  NumberOfService: "સેવા નંબર",
  DailyUserAndChannelWiseMAUReport:
    "દૈનિક વપરાશકર્તા અને ચેનલ મુજબનો MAU અહેવાલ",

  // Primary Identifier Change Report
  PrimaryIdentifierChangeReport: "પ્રાથમિક ઓળખકર્તા બદલો અહેવાલ",
  OldSource: "જૂનો સ્ત્રોત",
  NewSource: "નવો સ્ત્રોત",
  OldCardaccountNo: "જૂનું કાર્ડ/ખાતું નં.",
  NewCardaccountNo: "નવું કાર્ડ/ખાતું નં.",
  ChangedBy: "દ્વારા બદલાયેલ",
  ChangedDate: "બદલાયેલ તારીખ",

  // Device Change Report
  DeviceChangeReport: "ઉપકરણ ફેરફાર અહેવાલ",

  // Currently Login Customer Details Report
  CurrentlyLoginCustomerDetailsReport: "હાલમાં ગ્રાહક વિગતો અહેવાલ લોગિન કરો",
  LastLoginDateTime: "છેલ્લું લૉગિન તારીખ સમય",
  LastActivityDateTime: "છેલ્લી પ્રવૃત્તિ તારીખ સમય",
  InactiveTime: "નિષ્ક્રિય સમય",
  TTL: "TTL",
  LastActivityType: "છેલ્લી પ્રવૃત્તિનો પ્રકાર",
  LastActivityDescription: "છેલ્લી પ્રવૃત્તિનું વર્ણન",

  // Mobile Recharge Details Report
  MobileRechargeDetailsReport: "મોબાઇલ રિચાર્જ વિગતો અહેવાલ",
  ConnectionType: "જોડાણ પ્રકાર",
  OTPMobileNumber: "OTP મોબાઇલ નંબર",
  OTPEmailID: "OTP ઈમેલ આઈડી",

  // Account Deletion Request Report
  AccountDeletionRequestReport: "ખાતું કાઢી નાખવાની વિનંતીનો અહેવાલ",
  PrimaryCBCID: "પ્રાથમિક CB/CID",
  CheckerDate: "પરીક્ષક તારીખ",

  // Topup Reversal Report
  TopupReversalReport: "ટોપઅપ રિવર્સલ અહેવાલ",
  TopupTranCode: "ટોપઅપ ટ્રાન કોડ",
  MerechantRefID: "વેપારી રેફ. ID",
  AmountStatus: "રકમની સ્થિતિ",
  RequestIP: "વિનંતી IP",
  Rechargedate: "રિચાર્જની તારીખ",

  // Merchant Transaction Reversal Report
  MerchantTransactionReversalReport: "વેપારી વ્યવહાર રિવર્સલ અહેવાલ",
  ReversedBy: "દ્વારા વિપરીત",
  ReversedDateTime: "વિપરિત તારીખ સમય",
  AcceptedDateTime: "સ્વીકૃત તારીખ સમય",
  ReversedMachineName: "વિપરીત મશીનનું નામ",
  AcceptedMachineName: "સ્વીકૃત મશીનનું નામ",

  // User Status Change Audit Report
  UserStatusChangeAuditReport: "વપરાશકર્તા સ્થિતિ બદલો ઓડિટ અહેવાલ",
  NewStatus: "નવી સ્થિતિ",

  //Utility Bill Payment Report
  UtilityBillPaymentReport: "ઉપયોગિતા બિલ ચુકવણી અહેવાલ",
  Category: "શ્રેણી",
  TrnStatus: "Trn સ્થિતિ",
  Retrieve: "પુનઃપ્રાપ્ત કરો",
  BillNumber: "બિલ નંબર",
  GrandTotal: "ગ્રાન્ડ ટોટલ",
  OTPMobileNo: "OTP મોબાઈલ નં.",
  TransactionRefID: "વ્યવહાર સંદર્ભ. ID",
  OtherDetails: "અન્ય વિગતો",

  // Daily Service And Channel Wise Charges report
  DailyServiceAndChannelWiseChargesreport:
    "દૈનિક સેવા અને ચેનલ મુજબના શુલ્કનો અહેવાલ",
  MonthlyServiceAndChannelWiseChargesReport:
    "માસિક સેવા અને ચેનલ મુજબના શુલ્કનો અહેવાલ",

  // Insurance Premium Payment Report
  InsurancePremiumPaymentReport: "વીમા પ્રીમિયમ ચુકવણી અહેવાલ",
  CompanyName: "કંપની નું નામ",
  TransferType: "સ્થાનાંતરણનો પ્રકાર",
  ToAccount: "ખાતા માટે",

  // MFS Transfer Transation Details
  MFSTransferTransationDetails: "MFS ટ્રાન્સફર વ્યવહાર વિગતો",
  TransationDate: "વ્યવહારની તારીખ",
  TransationType: "વ્યવહારનો પ્રકાર",

  // Customer Wise Global Limit Usage Report
  CustomerWiseGlobalLimitUsageReport:
    "ગ્રાહક મુજબ વૈશ્વિક મર્યાદા વપરાશ અહેવાલ",
  GlobalLimit: "વૈશ્વિક મર્યાદા",
  TransactionCount: "વ્યવહારની ગણતરી",
  MFSvolume: "MFS વોલ્યુમ",
  WithinBankVolume: "બેંક વોલ્યુમમાં",
  OtherBankVolume: "અન્ય બેંક વોલ્યુમ",
  PaymentVolume: "ચુકવણીનું પ્રમાણ",

  // IDTP Registration Report
  IDTPRegistrationReport: "IDTP નોંધણી અહેવાલ",
  VID: "VID",
  DefualtDebitAccount: "ડિફૉલ્ટ ડેબિટ ખાતું",
  DefualtCreditAccount: "ડિફૉલ્ટ ક્રેડિટ ખાતું",
  DefualtRTPAccount: "ડિફૉલ્ટ FTP ખાતું",
  RegistrationType: "નોંધણીનો પ્રકાર",

  // IDTP Transfer Report
  IDTPTransferReport: "IDTP ટ્રાન્સફર અહેવાલ",
  SenderVID: "VID મોકલનાર",
  ReceiverVID: "VID પ્રાપ્તકર્તા",
  ReceiverName: "પ્રાપ્તકર્તાનું નામ",
  InterOperableFee: "આંતરસંચાલિત ફી",
  PlatformFee: "પ્લેટફોર્મ ફી",
  RTPID: "RTP ID",
  SwiftCode: "સ્વિફ્ટ કોડ",
  SDKResponseCode: "SDK પ્રતિભાવ કોડ",
  ReqestID: "વિનંતી ID",
  ReferanceNumber: "સંદર્ભ નંબર",
  RefNoSendingPSP: "સંદર્ભ નં. PSP મોકલી રહ્યું છે",
  RefNoReceivingPSP: "સંદર્ભ નં. PSP પ્રાપ્ત કરી રહ્યું છે",
  RefNoReceivingBank: "સંદર્ભ.નં.પ્રાપ્ત બેંક",
  RefNoIDTP: "સંદર્ભ નં. IDTP",

  // IDTP Create RTP Report
  IDTPCreateRTPReport: "IDTP RTP અહેવાલ બનાવો",
  UserVID: "વપરાશકર્તા VID",

  // IDTP Beneficiary Detail Report
  IDTPBeneficiaryDetailReport: "IDTP લાભાર્થી વિગતવાર અહેવાલ",
  BeneficiaryVID: "લાભાર્થી VID",

  // IDTP Transaction PIN Change Report
  IDTTransactionPINChangeReport: "IDTP ટ્રાન્ઝેક્શન PIN ફેરફાર અહેવાલ",

  // Password Reset Through Admin Panel Report
  PasswordResetThroughAdminPanelReport:
    "એડમિન પેનલ અહેવાલ દ્વારા પાસવર્ડ રીસેટ કરો",
  MakerMachine: "નિર્માતા મશીન",
  CheckerMachine: "તપાસકર્તા મશીન",

  // IDTP Forgot PIN Report
  IDTPForgotPINReport: "IDTP પિન રિપોર્ટ ભૂલી ગયા",
  VirtualID: "વર્ચ્યુઅલ ID",
  AcOrCardNumber: "ખાતું અથવા કાર્ડ નંબર",

  // IDTP RTP Decline Report
  IDTPRTPDeclineReport: "IDTP RTP અસ્વીકાર અહેવાલ",
  SenderName: "મોકલનારનું નામ",
  SenderVirtualID: "મોકલનાર વર્ચ્યુઅલ ID",

  // Virtual Card Request Report
  VirtualCardRequestReport: "વર્ચ્યુઅલ કાર્ડની વિનંતીનો અહેવાલ",
  CardProductName: "કાર્ડ ઉત્પાદન નામ",
  NameOnCard: "કાર્ડ પરનું નામ",
  CurrencyCode: "ચલણ કોડ",
  PassportNumber: "પાસપોર્ટ નંબર",
  CorrespondenceAddress: "પત્રવ્યવહાર સરનામું",

  // Dynamic Report Configure
  DynamicReportConfigure: "ડાયનેમિક રિપોર્ટ રૂપરેખાંકિત કરો",
  SQLANSIQuerySyntax: "SQL ANSI પ્રશ્ન સિંટેક્સ",
  PleaseEnterSQLSyntax: "કૃપા કરીને SQL સિંટેક્સ દાખલ કરો.",
  PleaseVerifySQLSyntax: "કૃપા કરીને SQL સિંટેક્સ સરખું છે તે ચકાસો.",
  Parameters: "પેરામીટર્સ",
  Title: "શીર્ષક",
  EnterTitle: "શીર્ષક દાખલ કરો",
  RetrievalType: "પુનઃપ્રાપ્તિ પ્રકાર",
  DisableGroupBy: "ગ્રૂપ દ્વારા અયક્ત કરો",
  HideAmountIn: "માત્રા છુપાઓ",
  HideFooter: "ફુટર છુપાઓ",
  ColumnAccessor: "કૉલમ એક્સેસર",
  EnterColumnAccessor: "કૉલમ એક્સેસર દાખલ કરો",
  ColumnName: "કૉલમ નામ",
  EnterColumnName: "કૉલમ નામ દાખલ કરો",
  ColumnWidth: "કૉલમ પહોળાઈ",
  EnterColumnWidth: "કૉલમ પહોળાઈ દાખલ કરો",
  ColumnType: "કૉલમ પ્રકાર",
  EnterColumnType: "કૉલમ પ્રકાર દાખલ કરો",
  ColumnFilterType: "કૉલમ ફિલ્ટર પ્રકાર",
  IsVisible: "દૃશ્યમાન છે",
  CreatedBy: "દ્વારા બનાવેલ",
  CreatedDate: "બનાવવાળી તારીખ",
  QuerySuccessfullyVerified: "પ્રશ્ન સફળતાપૂર્વક ચકાસ્યો.",
  ColumnFormat: "કૉલમ ફોર્મેટ",
  EnterColumnFormat: "કૉલમ ફોર્મેટ દાખલ કરો",
  WhereSequence: "ક્યાં અનુક્રમ",
  EnterWhereSequence: "ક્યાં અનુક્રમ દાખલ કરો",
  AccessRights: "ઍક્સેસ અધિકારો",
  DynamicReportAccessRights: "ડાયનેમિક રિપોર્ટ ઍક્સેસ અધિકારો",
  Userrightsupdatedsuccessfully: "વપરાશકર્તા અધિકારો સફળતાપૂર્વક અપડેટ થયા.",
  Verify: "ચકાસો",
  Done: "થઈ ગયું",

  UserList: "વપરાશકર્તા યાદી",
  Club: "ક્લબ",

  startswith: "સાથે શરૂ થાય છે",
  endswith: "સાથે અંત થાય છે",
  equal: "સમાન",
  contains: "સમાવે છે",

  PleaseSelectValidStartTime: "મહેરબાની કરીને માન્ય શરુઆતનો સમય પસંદ કરો",
  PleaseSelectValidEndTime: "મહેરબાની કરીને માન્ય સમાપ્તિ સમય પસંદ કરો",
  MonthlyLimitshouldgreaterthanorequaltoDailyLimit:
    "માસિક મર્યાદા દૈનિક મર્યાદા કરતા વધારે અથવા તેની બરાબર હોવી જોઈએ",
  MonthlyLimitshouldgreaterthanorequaltoWeeklyLimit:
    "માસિક મર્યાદા સાપ્તાહિક મર્યાદા કરતા વધારે અથવા તેની બરાબર હોવી જોઈએ",
  MaximumAmountshouldgreaterthanorequaltoMinimumAmount:
    "મહત્તમ રકમ ન્યૂનતમ રકમ કરતાં વધુ અથવા તેની બરાબર હોવી જોઈએ",
  WeeklyLimitshouldgreaterthanorequaltoDailyLimit:
    "સાપ્તાહિક મર્યાદા દૈનિક મર્યાદા કરતા વધારે અથવા તેની બરાબર હોવી જોઈએ",

  viewmode: "જુઓ મોડ",
  newmode: "નવો મોડ",
  editmode: "ફેરફાર મોડ",
  confirmmode: "પુષ્ટિ મોડ",
  addmode: "ઉમેરો મોડ",

  SelectCompute: "ગણતરી પસંદ કરો",
  BusinessDayhasbeennotgeneratedPleasegenerateaBusinessDaythroughtheViewDetailsScreen:
    "વ્યવસાય દિવસ જનરેટ કરવામાં આવ્યો નથી. કૃપા કરીને જુઓ વિગતો સ્ક્રીન દ્વારા વ્યવસાય દિવસ જનરેટ કરો.",
  SelectBranchName: "શાખાનું નામ પસંદ કરો",
  StartdatemustbegreaterthanpreviousEnddate:
    "પ્રારંભ તારીખ અગાઉની સમાપ્તિ તારીખ કરતાં મોટી હોવી આવશ્યક છે",
  SelectParentType: "પેરેન્ટ ટાઇપ પસંદ કરો",
  SelectLeavesTemplate: "લીવ્ઝ ટેમ્પલેટ પસંદ કરો",
  SelectCharges: "ચાર્જીસ પસંદ કરો",
  SelectOperatorType: "ઑપરેટરનો પ્રકાર પસંદ કરો",
  SelectOptionType: "વિકલ્પનો પ્રકાર પસંદ કરો",
  SelectChargeTemplate: "ચાર્જ નમૂનો પસંદ કરો",
  SelectAccountSource: "ખાતા સ્ત્રોત પસંદ કરો",
  DragandDropor: "ખેંચો અને છોડો અથવા",
  Browse: "બ્રાઉઝ",
  DropFileshere: "ફાઇલો અહીં મૂકો",
  SelectSourceName: "સ્ત્રોતનું નામ પસંદ કરો",
  SelectSourceType: "સ્ત્રોત પ્રકાર પસંદ કરો",
  SelectDistrict: "જિલ્લો પસંદ કરો",
  SelectTransactionType: "ટ્રાન્ઝેક્શન પ્રકાર પસંદ કરો",
  SelectAccountType: "ખાતાનો પ્રકાર પસંદ કરો",
  SelectTenureType: "મુદતનો પ્રકાર પસંદ કરો",
  SelectRestrictionType: "પ્રતિબંધનો પ્રકાર પસંદ કરો",
  SelectUsecase: "કેસ વાપરો પસંદ કરો",
  SelectChannel: "ચેનલ પસંદ કરો",
  SelectDisplayType: "પ્રદર્શનનો પ્રકાર પસંદ કરો",
  SelectBannerType: "બેનરનો પ્રકાર પસંદ કરો",
  SelectTenureTypeFinacle: "મુદત નો પ્રકાર ફિનાકલ પસંદ કરો",
  SelectRenewal: "નવીકરણ પસંદ કરો",
  SelectDataType: "ડેટા પ્રકાર પસંદ કરો",
  SelectMFSService: "MFS સેવા પસંદ કરો",
  SelectDescription: "વર્ણન પસંદ કરો",
  SelectAllowDisallow: "મંજૂરી આપો/નકારો પસંદ કરો",
  SelectTemplate: "ટેમ્પલેટ પસંદ કરો",
  SelectCardStatus: "કાર્ડ સ્થિતિ પસંદ કરો",
  SelectOperationType: "ઓપરેશનનો પ્રકાર પસંદ કરો",
  SelectEnableStatus: "સ્થિતિ સક્ષમ પસંદ કરો",
  SelectDeviceOS: "ઉપકરણ O.S. પસંદ કરો",
  SelectServiceName: "સેવાનું નામ પસંદ કરો",
  SelectTemplateName: "નમૂનાનું નામ પસંદ કરો",
  SelectProductType: "ઉત્પાદન પ્રકાર પસંદ કરો",
  SelectLimitCurrency: "મર્યાદા ચલણ પસંદ કરો",
  SelectLanguageID: "ભાષા આઈડી પસંદ કરો",
  SelectMerchantID: "વેપારી ID પસંદ કરો",
  SelectTerminalID: "ટર્મિનલ ID પસંદ કરો",
  SelectCharge: "ચાર્જ પસંદ કરો",
  SelectGatewayNamePID: "ગેટવે નામ (PID) પસંદ કરો",
  SelectUserRole: "વપરાશકર્તા ભૂમિકા પસંદ કરો",
  SelectUserStatus: "વપરાશકર્તા સ્થિતિ પસંદ કરો",
  SelectActionMenu: "ક્રિયા મેનૂ પસંદ કરો",
  SelectResponseKey: "પ્રતિભાવ કી પસંદ કરો",
  SelectUserLevel: "વપરાશકર્તા સ્તર પસંદ કરો",
  SelectGroupName: "ગ્રુપ નામ પસંદ કરો",
  SelectUserSubType: "વપરાશકર્તા પેટા પ્રકાર પસંદ કરો",
  SelectNotificationTemplate: "સૂચનાનો નમૂનો પસંદ કરો",
  SelectUserLoginID: "વપરાશકર્તા લૉગિન ID પસંદ કરો",
  ErrorDetails: "ભૂલની વિગતો",
  ShowLess: "ઓછું દર્શાવો",
  ShowMore: "વધુ દર્શાવો",
  Atleastonerowmustbeindetail: "ઓછામાં ઓછી એક પંક્તિ વિગતવાર હોવી જોઈએ.",
  All: "બધા",
  UploadProfilePhoto: "પ્રોફાઇલ ફોટો અપલોડ કરો",
  Filenotfound: "ફાઇલ મળી નથી",
  Profilepictureupdatedsuccessfully: "પ્રોફાઇલ ચિત્ર સફળતાપૂર્વક અપડેટ થયું.",
  Zoom: "ઝૂમ કરો",
  Rotate: "ફેરવો",
  UpdatePhoto: "ફોટો અપડેટ કરો",
  ServiceChargeDetails: "સેવા ચાર્જ વિગતો",
  Addedsuccessfully: "સફળતાપૂર્વક ઉમેરવામાં આવ્યું",
  Updatedsuccessfully: "સફળતાપૂર્વક અપડેટ કરવામાં આવ્યું",
  EditChargeTemplate: "ચાર્જ ટેમ્પલેટ ફેરફાર કરો",
  AreyousureyouwanttodeletetheselectedRecord:
    "શું તમે ખાતરી છો કે તમે પસંદ કરેલ રેકોર્ડ ડિલિટ કરવા માંગો છો?",
  Disagree: "અસંમત",
  Agree: "સંમત",
  EditChecklistDetails: "ચેકલિસ્ટ વિગતો ફેરફાર કરો",
  EnterFromAmount: "મુંબઈ લખો",
  EnterToAmount: "લખો સુધી",
  EnterChargeAmount: "ચાર્જ રકમ દાખલ કરો",
  EnterChargePercent: "ચાર્જ ટકા દાખલ કરો",
  AddChargeTemplateDetail: "ચાર્જ ટેમ્પલેટ વિગતો ઉમેરો",
  AccessDenied: "પરવાનગી અસ્વીકાર!",
  Usernameisnotvalid: "વપરાશકર્તા નામ માન્ય નથી",
  OopsPageNotFound: "અરે! પેજ નથી મળ્યું",
  Pleaseselectatleastonecolumn: "કૃપા કરીને ઓછામાં ઓછી એક કૉલમ પસંદ કરો!",
  Nodatafoundtoexports: "નિકાસ કરવા માટે કોઈ ડેટા મળ્યો નથી!",
  ResendOTP: "OTP ફરીથી મોકલો",

  OTPVerification: "OTP ચકાસણી",
  PleaseEnterOTP: "કૃપા કરીને OTP દાખલ કરો",
  ForgotTOTP: "TOTP ભૂલી ગયા",

  SelectCategory: "શ્રેણી પસંદ કરો",
  SelectBillerName: "બિલરનું નામ પસંદ કરો",
  SelectTrnStatus: "Trn સ્થિતિ પસંદ કરો",
  SelectStatus: "સ્થિતિ પસંદ કરો",
  SelectOTPType: "OTP પ્રકાર પસંદ કરો",
  SelectMerchantName: "વેપારીનું નામ પસંદ કરો",
  SelectTransactionStatus: "ટ્રાન્ઝેક્શન સ્ટેટસ પસંદ કરો",
  SelectFrequency: "આવૃત્તિ પસંદ કરો",
  SelectAccessChannel: "ચેનલ ઍક્સેસ પસંદ કરો",
  AreyousureyouwanttodeletetheselectedRecords:
    "શું તમે ખરેખર પસંદ કરેલા રેકોર્ડ્સ કાઢી નાખવા માંગો છો",
  AllRecordssuccessfullydeleted: "બધા રેકોર્ડ્સ સફળતાપૂર્વક કાઢી નાખ્યા",
  LoginPasswordForceExpiryDaysmustbeavalidnumberbetween1to30:
    "લોગિન પાસવર્ડ ફોર્સ એક્સપાયરી ડેઝ 1 થી 30 ની વચ્ચેની માન્ય સંખ્યા હોવી આવશ્યક છે.",

  IDTPAliasUpdateReport: "IDTP ઉપનામ અપડેટ રિપોર્ટ",
  ExistingAlias: "હાલનું ઉપનામ",
  NewAlias: "ઉપનામ જુઓ",
  SelectLanguage: "ભાષા પસંદ કરો",
  AreyouSureyouwanttodeletethisrecord:
    "શું તમે ખરેખર આ રેકોર્ડ કાઢી નાખવા માંગો છો?",
  Recordsuccessfullydeleted: "રેકોર્ડ સફળતાપૂર્વક કાઢી નાખ્યો",
  Pleasewaitdeletingrecord: "કૃપા કરીને રેકોર્ડ કાઢી નાખવાની રાહ જુઓ",
  NoRecordsFoundclicktheaddbuttontoaddone:
    "કોઈ રેકોર્ડ્સ મળ્યા નથી, એક ઉમેરવા માટે ઉમેરો બટનને ક્લિક કરો",
  Maximize: "મહત્તમ કરો",
  EnterDefaultValue: "મૂળભૂત કિંમત દાખલ કરો",
  IsTotalWithoutCurrency: "કુલ ચલણ વિના છે",
  IsTotalWithCurrency: "કુલ ચલણ સાથે છે",
  IsVisibleCurrencySymbol: "દૃશ્યમાન ચલણ ચિહ્ન છે",
  IsCurrencyCode: "ચલણ કોડ છે",
  CurrencyReferenceColumn: "ચલણ સંદર્ભ કૉલમ",

  //Password Rotation
  PasswordRotation: "પાસવર્ડ રોટેશન",
  CurrentPassword: "અત્યારનો પાસવર્ડ",
  EnterCurrentPassword: "અત્યારનો પાસવર્ડ દાખલ કરો",
  EnterNewPassword: "નવો પાસવર્ડ દાખલ કરો",
  ConfirmNewPassword: "નવા પાસવર્ડની પુષ્ટી કરો",
  Enterconfirmnewpassword: "નવા પાસવર્ડની પુષ્ટિ કરો દાખલ કરો",
  CurrentPasswordisrequired: "અત્યારનો પાસવર્ડ જરૂરી છે.",
  Thenewpasswordcannotbethesameastheoldpassword:
    "નવો પાસવર્ડ જૂના પાસવર્ડ જેવો ન હોઈ શકે",
  Confirmnewpasswordisrequired: "પુષ્ટિ કરો કે નવો પાસવર્ડ જરૂરી છે.",
  NewPasswordandConfirmPassworddidnotmatched:
    "નવો પાસવર્ડ અને કન્ફર્મ પાસવર્ડ મેળ ખાતા નથી",
  Passwordsuccessfullychanged: "પાસવર્ડ સફળતાપૂર્વક બદલાયો.",

  //
  CardProductBin: "કાર્ડ ઉત્પાદન બિન",
  ModeofOperation: "કામગીરીની રીત",
  AccountStatus: "ખાતાની સ્થિતિ",

  //Push Notification Master
  PushNotificationMaster: "સૂચના માસ્ટરને દબાણ કરો",
  UserType: "વપરાશકર્તા પ્રકાર",
  SelectUserType: "વપરાશકર્તા પ્રકાર પસંદ કરો",
  ExecuteDate: "અમલ તારીખ",
  EnterExecuteDate: "અમલ તારીખ દાખલ કરો",
  SelectLoginID: "લોગિન આઈડી પસંદ કરો",
  EnterCustomerName: "ગ્રાહકનું નામ દાખલ કરો",
  EnterLastLoginDate: "છેલ્લી લૉગિન તારીખ દાખલ કરો",
  PushNotificationMasterConfirmation: "દબાણ સૂચના માસ્ટર પુષ્ટિકરણ",

  // Push Notification Template Configuration
  PushNotificationTemplateConfiguration: "દબાણ સૂચના ટેમ્પલેટ રૂપરેખાંકન",
  Subject: "વિષય",
  EnterSubject: "વિષય દાખલ કરો",
  EnterTemplateName: "નમૂનાનું નામ દાખલ કરો",
  PushNotificationTemplateConfigurationPreview:
    "સૂચના ટેમ્પલેટ કન્ફિગરેશન પૂર્વાવલોકન દબાણ કરો",
  EnterDeviceID: "ઉપકરણ ID દાખલ કરો",
  Preview: "પૂર્વાવલોકન",
  Test: "પરીક્ષણ",
  PushNotificationTemplateConfirmation: "દબાણ સૂચના ટેમ્પલેટ પુષ્ટિ",
  FromAmountshouldbelessToAmount: "રકમ માંથી રકમથી ઓછી હોવી જોઈએ",

  Mobilenumbermustbe11digitslong: "મોબાઈલ નંબર 11 અંક લાંબો હોવો જોઈએ",
  UserRestrictProcessing: "વપરાશકર્તા પ્રતિબંધિત પ્રક્રિયા",
  PrimaryStatus: "પ્રાથમિક સ્થિતિ",
  CardID: "કાર્ડ આઈ.ડી",
  EnterCardID: "કાર્ડ આઈ.ડી દાખલ કરો",
  TapPayDetails: "ટૅપ કરો અને વિગતો ની ચુકવણી કરો",
  TapPay: "ટૅપ કરો અને ચુકવણી કરો",

  //IBMB Product

  LanguageReq: "ભાષા*",
  MessageReq: "સંદેશ*",
  EnterMessage: "સંદેશ દાખલ કરો",
  MessageNoteReq: "સંદેશ નોંધ*",
  MessageNote: "સંદેશ નોંધ",
  EnterMessageNote: "સંદેશ નોંધ દાખલ કરો",
  EnterMessageCode: "સંદેશ કોડ દાખલ કરો",
  LanguageisAlreadyenteredatLine: "ભાષા પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",
  SelectCurrencyCode: "ચલણ કોડ પસંદ કરો",
  DefaultNote: "મૂળભૂત નોંધ",
  EnterDefaultNote: "મૂળભૂત નોંધ દાખલ કરો",

  CommonMessageTemplate: "સામાન્ય સંદેશનો નમૂનો",
  Message: "સંદેશ",
  SelectMessage: "સંદેશ પસંદ કરો",

  // password Policy Configuration

  PasswordPolicyConfiguration: "પાસવર્ડ નીતિ રૂપરેખાંકન",
  PasswordType: "પાસવર્ડ પ્રકાર",
  MinimumLength: "લઘુત્તમ લંબાઈ",
  MaximumLength: "મહત્તમ લંબાઈ",
  UpperCaseRequire: "અપરકેસ જરૂરી છે",
  LowerCaseRequire: "લોઅરકેસ જરૂરી છે",
  SpecialCharacterRequire: "વિશેષ અક્ષર જરૂરી છે",
  DigitsRequire: "અંકો જરૂરી છે",
  NoSpaces: "કોઈ જગ્યાઓ નથી",
  EnterPasswordType: "પાસવર્ડ પ્રકાર દાખલ કરો",
  EnterMinimumLength: "લઘુત્તમ લંબાઈ દાખલ કરો",
  EnterMaximumLength: "મહત્તમ લંબાઈ દાખલ કરો",
  NoofPreviousPasswordNotAllowed: "પાછલા પાસવર્ડોની સંખ્યા પરવાનગી આપવી નહીં",
  EnterNoofPreviousPasswordNotAllowed:
    "પાછલા પાસવર્ડોની સંખ્યા દાખલ કરો જે પરવાનગી આપવી નહીં",
  MinimumUpperCase: "લઘુત્તમ અપરકેસ",
  EnterMinimumUpperCase: "લઘુત્તમ અપરકેસ દાખલ કરો",
  MinimumLowerCase: "લઘુત્તમ લોઅરકેસ",
  EnterMinimumLowerCase: "લઘુત્તમ લોઅરકેસ દાખલ કરો",
  MinimumDigits: "લઘુત્તમ અંક",
  EnterMinimumDigits: "લઘુત્તમ અંક દાખલ કરો",
  MinimumSpecialCharater: "લઘુત્તમ વિશેષ અક્ષર",
  EnterMinimumSpecialCharater: "લઘુત્તમ વિશેષ અક્ષર દાખલ કરો",
  AllowedSpecialCharacter: "પરવાનગી આપેલા વિશેષ અક્ષર",
  EnterAllowedSpecialCharacter: "પરવાનગી આપેલા વિશેષ અક્ષર દાખલ કરો",
  MinimumEnglishCharacter: "લઘુત્તમ અંગ્રેજી અક્ષર",
  EnterMinimumEnglishCharacter: "લઘુત્તમ અંગ્રેજી અક્ષર દાખલ કરો",
  ExpireDays: "સમાપ્તિ દિવસો",
  EnterExpireDays: "સમાપ્તિ દિવસો દાખલ કરો",
  AlertBeforeExpireDays: "સમાપ્તિ દિવસો પહેલાં ચેતવણી",
  EnterAlertBeforeExpireDays: "સમાપ્તિ દિવસો પહેલાં ચેતવણી દાખલ કરો",
  Pleaseenteronlyspecialcharacters: "કૃપા કરીને ફક્ત વિશેષ અક્ષરો દાખલ કરો",

  EnterAccountSource: "ખાતા સ્ત્રોત દાખલ કરો",
  EnterAccountType: "ખાતાનો પ્રકાર દાખલ કરો",
  EditAllowed: "સંપાદિત કરવાની મંજૂરી",
  InternetBanking: "ઈન્ટરનેટ બેન્કિંગ",
  MobileBanking: "મોબાઇલ બેંકિંગ",
  MaskedAccountCardNo: "માસ્ક્ડ એકાઉન્ટ કાર્ડ નં",

  AccountCustomerID: "ખાતું ગ્રાહક ID",
  AccountRegCardNo: "ખાતું/રજી/કાર્ડ નં.",
  MakerRemarks: "નિર્માતા ટિપ્પણી",
  PrimaryCustomerID: "પ્રાથમિક ગ્રાહક આઈ.ડી",

  SecurityQuestionMasterConfiguration: "સુરક્ષા પ્રશ્ન માસ્ટર રૂપરેખાંકન",
  SecurityQuestion: "સુરક્ષા પ્રશ્ન",
  SecurityQuestionGroupCD: "સુરક્ષા પ્રશ્ન જૂથ",
  EnterSecurityQuestions: "સુરક્ષા પ્રશ્નો દાખલ કરો",
  SecurityQuestionConfigurationConfirmation: "સુરક્ષા પ્રશ્ન રૂપરેખાંકન પુષ્ટિ",
  SecurityQuestionConfiguration: "સુરક્ષા પ્રશ્ન રૂપરેખાંકન",
  SelectDefaultMessage: "મૂળભૂત સંદેશ પસંદ કરો",
  Unknownerroroccured: "અજાણી ભૂલ આવી",

  OtherBankMaster: "અન્ય બેંક માસ્ટર",
  OtherBranchMaster: "અન્ય શાખા માસ્ટર",
  OtherRegionMaster: "અન્ય ક્ષેત્ર માસ્ટર",

  // State Township MAster Configuration Screen

  StateTownshipMasterConfiguration: "રાજ્ય ટાઉનશિપ માસ્ટર સંરચના",
  StateCode: "રાજ્ય કોડ",
  EnterStateCode: "રાજ્ય કોડ દાખલ કરો",
  StateName: "રાજ્યનું નામ",
  EnterStateName: "રાજ્યનું નામ દાખલ કરો",
  TownshipCode: "ટાઉનશિપ કોડ",
  EnterTownshipCode: "ટાઉનશિપ કોડ દાખલ કરો",
  TownshipName: "ટાઉનશિપનું નામ",
  EnterTownshipName: "ટાઉનશિપનું નામ દાખલ કરો",
  // Suspense Account Template Configuration

  SuspenseAccountTemplateConfiguration: "સસ્પેન્સ એકાઉન્ટ ટેમ્પલેટ રૂપરેખાંકન",
  SuspenseAccountTemplateConfirmation: "સસ્પેન્સ એકાઉન્ટ નમૂનો પુષ્ટિકરણ",
  TransactionRemark1: "ટ્રાન્ઝેક્શન રિમાર્ક 1",
  EnterTransactionRemark1: "ટ્રાન્ઝેક્શન રિમાર્ક 1 દાખલ કરો",
  TransactionRemark2: "ટ્રાન્ઝેક્શન રિમાર્ક 2",
  EnterTransactionRemark2: "ટ્રાન્ઝેક્શન રિમાર્ક 2 દાખલ કરો",
  AccountTypeReq: "ખાતાનો પ્રકાર*",
  AccountTypeisAlreadyenteredatLine:
    "ખાતાનો પ્રકાર પહેલેથી જ લાઇન {0} પર દાખલ કરેલ છે",
  // Currency Limit Template Configuration

  CurrencyLimitTemplateConfiguration: "ચલણ મર્યાદા ટેમ્પલેટ કૉન્ફિગરેશન",
  CurrencyLimitTemplateConfirmation: "ચલણ મર્યાદા ટેમ્પલેટ પુષ્ટિ",
  DailyAmount: "દૈનિક રકમ",
  WeeklyAmount: "સાપ્તાહિક રકમ",
  MonthlyAmount: "માસિક રકમ",
  MaximumDailyCount: "દૈનિક મહત્તમ સંખ્યા",
  MaximumWeeklyCount: "સાપ્તાહિક મહત્તમ સંખ્યા",
  MaximumMonthlyCount: "માસિક મહત્તમ સંખ્યા",
  CurrencyCodeReq: "ચલણ કોડ*",
  EnterOrderBy: "ઓર્ડર દ્વારા દાખલ કરો",

  CurrencyReq: "ચલણ*",
  SelectCurrency: "ચલણ પસંદ કરો",
  EitherChargeAmountOrChargePercentageIsRequired:
    "ચાર્જ રકમ અથવા ચાર્જ ટકાવારીમાં કોઈ એક જરૂરી છે",

  AccountSpecificChargeTemplate: "ખાતાનું નિશ્ચિત ચાર્જ ટેમ્પલેટ",
  ServiceChargeTemplateReq: "સેવા ચાર્જ ટેમ્પલેટ*",
  AccountClassificationReq: "ખાતાનું વર્ગીકરણ*",
  AcParameterMappingTemplateReq: "ખાતું પેરામિટર મૅપિંગ ટેમ્પલેટ*",
  AccountSpecificChargeTemplateConfirmation:
    "ખાતાનું નિશ્ચિત ચાર્જ ટેમ્પલેટ પુષ્ટિ",
  AccountSourceNumber: "ખાતું/સ્રોત નંબર",
  ThisCurrencyAlreadyExists: "આ ચલણ પહેલેથી જ ઉપલબ્ધ છે",
  AccountParametersMappingTemplate: "ખાતું પેરામિટર મૅપિંગ ટેમ્પલેટ",
  FromSourceKeyValueConfigMapping: "સ્રોત કી મૂલ્ય રૂપરેખા માપિંગમાંથી",
  AcParameterMappingTemplate: "ખાતું પેરામિટર મૅપિંગ ટેમ્પલેટ",
  ConfigurationType: "ગોઠવણ પ્રકાર",
  PresetAmountConfiguration: "પૂર્વનિર્ધારિત રકમ ગોઠવણ",
  TemplateCode: "ટેમ્પલેટ કોડ",

  LimitTemplateReq: "મર્યાદા ટેમ્પલેટ*",
  LimitTemplate: "મર્યાદા ટેમ્પલેટ",
  SelectLimitTemplate: "મર્યાદા ટેમ્પલેટ પસંદ કરો",
  AccountTemplate: "એકાઉન્ટ નમૂનો",
  SelectAccountTemplate: "એકાઉન્ટ નમૂનો પસંદ કરો",
  GloballimitTemplate: "વૈશ્વિક મર્યાદા ટેમ્પલેટ",
  SelectGloballimitTemplate: "વૈશ્વિક મર્યાદા ટેમ્પલેટ પસંદ કરો",

  ProfileTemplate: "પ્રોફાઇલ નમૂનો",
  ProfileTemplateConfirmation: "પ્રોફાઇલ નમૂનો પુષ્ટિકરણ",
  // service master

  ServiceMaster: "સેવા માસ્ટર",
  ServiceMasterConfirmation: "સેવા માસ્ટર પુષ્ટિ",
  SuspenseAccountDetails: "સસ્પેન્સ ખાતા વિગતો",
  ChargeAllow: "ચાર્જ મંજૂર કરો",
  SuspenseAccountTemplate: "સસ્પેન્સ ખાતા નો નમૂનો",
  SelectSuspenseAccountTemplate: "સસ્પેન્સ ખાતા નો નમૂનો પસંદ કરો",
  AccountSourceReq: "ખાતા સ્ત્રોત*",

  //Wallet Master
  WalletMaster: "વૉલેટ માસ્ટર",
  WalletMasterConfirmation: "વૉલેટ માસ્ટર પુષ્ટિ",
  WalletType: "વૉલેટનો પ્રકાર",
  EnterWalletType: "વૉલેટનો પ્રકાર દાખલ કરો",
  WalletName: "વૉલેટનું નામ",
  EnterWalletName: "વૉલેટનું નામ દાખલ કરો",
  WalletIDValidateRegex: "વૉલેટ આઈડી વેલિડેટ કરવા માટેનો રેગ્યુલર એક્સપ્રેશન",
  EnterWalletIDValidateRegex:
    "વૉલેટ આઈડી વેલિડેટ કરવા માટેનો રેગ્યુલર એક્સપ્રેશન દાખલ કરો",
  WalletIDRegExpNotaValid: "વૉલેટ આઈડી રેગ્યુલર એક્સપ્રેશન માન્ય નથી",

  Areyousureyouwanttoupdatetheprofiletemplateforthisuser:
    "શું તમે ખરેખર આ વપરાશકર્તા માટે પ્રોફાઇલ ટેમ્પલેટ અપડેટ કરવા માંગો છો?",
  Theholidaydatemustbebetweenthestartdateandenddate:
    "રજાની તારીખ પ્રારંભ તારીખ અને સમાપ્તિ તારીખ વચ્ચેની હોવી જોઈએ.",
  SelectCardType: "કાર્ડનો પ્રકાર પસંદ કરો",
  CardStatusisAlreadyenteredatLine:
    "કાર્ડની સ્થિતિ પહેલાથી જ લાઇન {0} પર દાખલ કરેલ છે",
  CardCategory: "કાર્ડ શ્રેણી",
  CardApplyConfirmation: "કાર્ડ અરજી પુષ્ટિ",
  ProofType: "સાબિતીનો પ્રકાર",
  ProofValue: "સાબિતી મૂલ્ય",
  CardApplyDetails: "કાર્ડની અરજીની વિગતો",
  ClicktoViewFullImage: "સંપૂર્ણ છબી જોવા માટે ક્લિક કરો",
  DoubleClicktoCloseImage: "છબી બંધ કરવા માટે ડબલ ક્લિક કરો",
  RequestDetail: "વિનંતી વિગતો",
  ApplyAnnualExpense: "વાર્ષિક ખર્ચ લાગુ કરો",
  EnterApplyAnnualExpense: "વાર્ષિક ખર્ચ દાખલ કરો",
  ApplyAnnualIncome: "વાર્ષિક આવક લાગુ કરો",
  EnterApplyAnnualIncome: "વાર્ષિક આવક દાખલ કરો",
  ApplyCompanyName: "કંપનીનું નામ લાગુ કરો",
  EnterApplyCompanyName: "કંપનીનું નામ દાખલ કરો",
  ApplyPosition: "સ્થાન લાગુ કરો",
  EnterApplyPosition: "સ્થાન દાખલ કરો",
  EnterCardCategory: "કાર્ડ શ્રેણી દાખલ કરો",
  CredentialsResetRequestHistoryReport:
    "પ્રમાણપત્ર રીસેટ વિનંતી ઇતિહાસ રિપોર્ટ",
  AuthenticationFlow: "પ્રમાણીકરણ પ્રવાહ",
  BankRegion: "બૅન્ક ક્ષેત્ર",
  MobileAccountLinkReport: "મોબાઇલ એકાઉન્ટ લિંક રિપોર્ટ",
  ActionFlag: "ક્રિયા ધ્વજ",
  TRFType: "TRF પ્રકાર",
  WalletTopUpDetails: "વૉલેટ ટોપ અપ વિગતો",
  ToWalletId: "વૉલેટ આઈડી પર",
  ToWalletNM: "વૉલેટ નામ પર",
  OtherBankFundTransferDetails: "અન્ય બૅન્ક ફંડ ટ્રાન્સફર વિગતો",
  NRCFundTransferDetails: "એનઆરસી ફંડ ટ્રાન્સફર વિગતો",
  CreditCardPaymentDetails: "ક્રેડિટ કાર્ડ પેમેન્ટ વિગતો",
  RecipientMobileNo: "પ્રાપ્તકર્તાનું મોબાઇલ નંબર",
  FormAccountNo: "એકાઉન્ટ નંબર થી",
  CardResetPinReport: "કાર્ડ રીસેટ પિન રિપોર્ટ",
  PinChangeReason: "પિન બદલાવનું કારણ",
  CardApplicationDetails: "કાર્ડ એપ્લિકેશન વિગતો",
  PartyDetails: "પાર્ટી વિગતો",
  BlockUnblockCardPinDetails: "કાર્ડ પિન બ્લોક/અનબ્લોક વિગતો",
  CardActivationDetails: "કાર્ડ સક્રિય કરવાનું વિગતો",
  InActiveDate: "સક્રિય ન હોવાનો દિવસ",
  TransactionAllowed: "ટ્રાન્ઝેક્શન મંજૂર છે",
  selectTransactionAllowed: "ટ્રાન્ઝેક્શન મંજૂર પસંદ કરો",
  Mobilenumbermustbe9digitslong: "મોબાઇલ નંબર 9 અંકોનો હોવો જોઈએ",
  Mobilenumbermustbe7digitslong: "મોબાઇલ નંબર 7 અંકોનો હોવો જોઈએ",
  SearchServiceName: "સેવાનું નામ શોધો",
  AppliedLimits: "લાગુ કરેલ મર્યાદાઓ",
  EnterAccountCardNumber: "ખાતું/કાર્ડ નંબર દાખલ કરો",
  EnterAccountCustomerID: "ખાતા ની ગ્રાહક ID દાખલ કરો",

  StatementType: "નિવેદનનો પ્રકાર",
  SentStatus: "મોકલેલી સ્થિતિ",
  AccountStatementReport: "ખાતાનું નિવેદનનો અહેવાલ",
  ChargeAmount: "શુલ્કની રકમ",
  ToSourceFlag: "સ્ત્રોત ફ્લેગ માટે",
  ServiceUnavailableAction: "સેવા ઉપલબ્ધ નથી ક્રિયા",
  SelectServiceUnavailableAction: "સેવા ઉપલબ્ધ નથી તે ક્રિયાને પસંદ કરો",
  ServiceUnavailableActionReq: "સેવા ઉપલબ્ધ નથી ક્રિયા*",
  AllowAccess: "પ્રવેશની પરવાનગી આપો",
  ProfileReq: "પ્રોફાઇલ*",
  SelectProfile: "પ્રોફાઇલ પસંદ કરો",
  ThisChannelalreadyexists: "આ ચેનલ પહેલેથી જ અસ્તિત્વમાં છે",
  ThisProfilealreadyexists: "આ પ્રોફાઇલ પહેલેથી જ અસ્તિત્વમાં છે",
  BranchMasterConfirmation: "શાખા માસ્ટર પુષ્ટિ",
  FromSourceKeyValueConfigurationConfirmation:
    "સ્ત્રોત કી મૂલ્ય રૂપરેખાંકન પુષ્ટિ",
  FromSourceKeyValueConfirmation: "સ્ત્રોત કી મૂલ્ય પુષ્ટિ",

  IntraFundTransferDetails: "ઇનટ્રા ફંડ ટ્રાન્સફર વ્યવહારમાં વિગતો",
  ErrorCode: "ભૂલ કોડ",
  ToAccountCardNo: "એકાઉન્ટ/કાર્ડ નંબર",
  CardApplicationPartiesDetails: "કાર્ડ એપ્લિકેશન પક્ષોની વિગતો",
  FromAccountBalance: "એકાઉન્ટ બેલેન્સથી",
  RetryCount: "પુન: પ્રયાસ ગણતરી",
  CallResponse: "કૉલ પ્રતિક્રિયા",
  ReferenceID: "સંદર્ભ આઈડી",
  RefereneceDate: "સંદર્ભ તારીખ",
  BatchID: "બેચ આઈડી",
  APIStatus: "API સ્થિતિ",
  APIExecutionTime: "API અમલનો સમય",
  CardProductMaster: "કાર્ડ પ્રોડક્ટ માસ્ટર",
  CardProductMasterConfirmation: "કાર્ડ પ્રોડક્ટ માસ્ટર પુષ્ટિ",
  ChannelLimit: "ચેનલ મર્યાદા",
  ChannelLimitConfiguration: "ચેનલ મર્યાદા કૉન્ફિગરેશન",
  ChannelLimitConfirmation: "ચેનલ મર્યાદા પુષ્ટિ",
  TransactionAllowedReq: "ટ્રાન્ઝેક્શન મંજૂર છે*",

  BranchServiceStatusTitle: "શાખા સેવા સ્થિતિ અપડેટ",
  BranchServiceStatusCountNote: "પસંદ કરેલી શાખા: ",
  BranchServiceStatusNote:
    "ટિપ્પણી: કૃપા કરીને તમામ પસંદ કરેલી શાખાઓ માટે સેવા અને સ્થિતિ અપડેટ કરવા માટે પસંદ કરો.",
  BranchServiceStatusUpdateMsg:
    "શું તમે ખરેખર તમામ પસંદ કરેલી શાખાઓમાં {1} સેવાને {0} કરવા માંગો છો?",
  Specialcharactersandspacesarenotallowed:
    "Special characters and spaces are not allowed",
};
